<template>
  <div class="wrapper boxswrap">
    <header-nav :index_num="index_num"></header-nav>
    <div id="box" v-loading='box_loading'>
      <!-- 顶部导航 -->
      <div class="top">
        <div class="span">
          <span @click="btn(0)" :class="sub == 0 ? 'style' : ''" style="cursor: pointer">项目进度</span>
          <span @click="btn(1)" :class="sub == 1 ? 'style' : ''" style="cursor: pointer">项目信息</span>
          <span @click="btn(2)" :class="sub == 2 ? 'style' : ''" style="cursor: pointer">项目执行信息</span>
        </div>
        <div class="daochu" v-if="sub == 1" @click="download()">项目导出</div>
      </div>
      <!-- 项目进度 -->
      <div class="bobb" v-if="sub == 0">
        <div>
          <div class="left">
            <div class="time">
              <template v-for="(time, index) in zDate.date">
                <span v-if="index < 5" :key="index">{{ time }}</span>
              </template>
            </div>
            <div class="jdt">
              <!-- 已申报 -->
              <div v-for="(i, j) in zDate" :key="j">
                <img class="sx0" :src="imgUrl1.sx0" alt />
                <img class="d0" :src="imgUrl1.d1" v-if="i.type" />
                <img class="d1" :src="imgUrl1.d0" v-else />
              </div>
              <img :src="imgUrl1.sx1" alt style="width:3px;height:61px;" />
            </div>
            <div class="bb">
              <div class="o" v-for="(i, j) in zDate" :key="j">
                <span>{{ i.string }}</span>
                <img class="oo" :src="imgUrl1.d0" alt />
              </div>
            </div>
          </div>
        </div>
        <div class="newButton" v-if="status == 10">
          <button type="primary" class="newBtn" @click="hreftwo" style="cursor: pointer">
            创建项目执行信息
          </button>
        </div>
        <div class="right" style="width: 675px">
          <img :src="imgUrl1.xd" style="width: 535px; height: 698px" />
        </div>
      </div>
      <div class="boxx" v-if="sub == 1" :class="popupStatus == true ? 'fliter' : ''" style="overflow: hidden;">
        <h3 class="title1" style="margin-top: 10px">一、基本信息</h3>
        <!-- 项目申报书和项目实施方案 -->
        <div class="options_btn_box">
          <div class="options_btn">
            <span class="addN">项目申报书:</span>
            <span v-if="shili20">
              <span :title="shili20? shili20.split('_')[0] + '' + (shili20.split('_')[0].includes('.')? '': shili20.split('.')[1]): '未上传'">
                {{ shili20 ? shili20 : "未上传" }}</span>
              <a :href="shili20url" target="_blank" class="yulan" style="color: #000fff" v-if="down20">{{
                  shili20.substring(shili20.lastIndexOf(".") + 1) == "jpg" ||
                  shili20.substring(shili20.lastIndexOf(".") + 1) == "pdf" ||
                  shili20.substring(shili20.lastIndexOf(".") + 1) == "jpeg" ||
                  shili20.substring(shili20.lastIndexOf(".") + 1) == "png"
                    ? "预览"
                    : "下载"
                }}</a>
            </span>
            <span style="display: flex" v-if="!shili20">
              <el-upload class="avatar-uploader" :action="$upload" :show-file-list="false" :on-success="handlesuccess20" :before-upload="beforeAvatarUpload" :http-request="uploadfile20" accept=".pdf">
                <el-button size="small" type="primary">点此上传</el-button>
              </el-upload>
            </span>
            <el-button size="small" type="primary" style="margin-left: 10px" @click="delete20" v-if="show20">删除</el-button>
            <el-button size="small" v-if="show20" type="primary" @click="save20">提交</el-button>
          </div>
          <div class="options_btn">
            <span class="addN">项目实施方案:</span>
            <span v-if="shili21">
              <span :title="
                  shili21
                    ? shili21.split('_')[0] +
                      '' +
                      (shili21.split('_')[0].includes('.')
                        ? ''
                        : shili21.split('.')[1])
                    : '未上传'
                ">{{ shili21 ? shili21 : "未上传" }}</span>

              <a :href="shili21url" target="_blank" class="yulan" style="color: #000fff" v-if="down21">{{
                shili21.substring(shili21.lastIndexOf(".") + 1) == "jpg" ||
                shili21.substring(shili21.lastIndexOf(".") + 1) == "pdf" ||
                shili21.substring(shili21.lastIndexOf(".") + 1) == "jpeg" ||
                shili21.substring(shili21.lastIndexOf(".") + 1) == "png"
                    ? "预览"
                    : "下载"
                }}</a>
            </span>
            <span style="display: flex" v-if="!shili21">
              <el-upload class="avatar-uploader" :action="$upload" :show-file-list="false" :on-success="handlesuccess21" :before-upload="beforeAvatarUpload" :http-request="uploadfile21" accept=".pdf">
                <el-button size="small" type="primary">点此上传</el-button>
              </el-upload>
            </span>

            <el-button size="small" type="primary" style="margin-left: 10px" @click="delete21" v-if="show21">删除</el-button>
            <el-button size="small" v-if="show21" type="primary" @click="save21">提交</el-button>
          </div>
        </div>
        <!-- pdf导出页面 -->
        <div id="pdfDom">
          <div class="one-o">
            <ul>
              <li>项目名称：{{ zData.name }}</li>
              <li>项目申报单位：{{ zData.company }}</li>
              <li>项目联合承接单位：{{zData.lianhe_company}}</li>
              <li>项目类型：{{ zData.tid }}</li>
              <li>项目落地区域：{{ zData.rid }}</li>
              <li>一级项目方向：{{ zData.first_level }}</li>
              <li>二级项目方向：{{ zData.secondary }}</li>
              <li>三级项目方向：{{ zData.fieldeara }}</li>
              <li>项目有效期: {{ zData.aterm + "至" + zData.fterm }}</li>
              <li>项目服务领域：{{ zData.attribute }}</li>
              <li>通讯地址：{{ zData.postaladdress }}</li>
              <li>电子信箱：{{ zData.pmail }}</li>
              <li>申报单位属性：{{ zData.fax_tel }}</li>
              <li>邮政编码：{{ zData.postalcode }}</li>
            </ul>
            <ul>
              <li>法定代表人：{{ zData.plegal }}</li>
              <li>法人代码：{{ zData.plcode }}</li>
              <li>负责人姓名：{{ zData.pname }}</li>
              <li>职务：{{ zData.poster }}</li>
              <li>办公电话：{{ zData.poffice_tel }}</li>
              <li>手机：{{ zData.aphone }}</li>
              <li>联系人姓名：{{ zData.cname }}</li>
              <li>职务：{{ zData.cpost }}</li>
              <li>办公电话：{{ zData.coffice_tel }}</li>
              <li>手机：{{ zData.cphone }}</li>
            </ul>
            <ul>
              <li>项目主责单位：{{ zData.prespo }}</li>
              <li>通讯地址：{{ zData.respoadd }}</li>
              <li>邮政编码：{{ zData.respopcode }}</li>
              <li>传真电话：{{ zData.respophone }}</li>
              <li>电子信箱：{{ zData.respomail }}</li>
              <li>负责人姓名：{{ zData.respopname }}</li>
              <li>职务：{{ zData.respopost }}</li>
              <li>手机：{{ zData.respoptel }}</li>
              <li>办公电话：{{ zData.respoophone }}</li>
              <li>联系人姓名：{{ zData.respocname }}</li>
              <li>职务：{{ zData.respocpost }}</li>
              <li>办公电话：{{ zData.respocophone }}</li>
              <li>手机：{{ zData.respoctel }}</li>
            </ul>
          </div>
          <h3 class="title1">二、申报单位简介</h3>
          <div class="one-e">
            <p v-html="zData.decldes">{{ zData.decldes }}</p>
          </div>
          <h3 class="title1">三、项目简介</h3>
          <div class="one-e">
            <p v-html="zData.prodes">{{ zData.prodes }}</p>
          </div>
          <h3 class="title1">四、项目架构</h3>
          <h4>(一) 项目目标</h4>
          <div class="one-e">
            <p v-html="zData.prodemo">{{ zData.prodemo }}</p>
          </div>
          <h4>
            (二) 团队组成
          </h4>
<!--          <h5>1.项目实施的已有基础</h5>-->
          <div class="one-e">
            <p v-html="zData.prodemojc">{{ zData.prodemojc }}</p>
          </div>
          <h5>(三)项目内容</h5>
          <div class="one-e">
            <p v-html="zData.prodemotj">{{ zData.prodemotj }}</p>
          </div>
          <h5>(四)项目活动</h5>
          <div class="one-e">
            <p v-html="zData.prodemojd">{{ zData.prodemojd }}</p>
          </div>
          <h5>(五)预期成效</h5>
          <div class="one-e">
            <p v-html="zData.prodemoxg">{{ zData.prodemoxg }}</p>
          </div>
<!--          <h5>5.项目团队及分工</h5>-->
<!--          <div class="one-e">-->
<!--            <p v-html="zData.prodemofg">{{ zData.prodemofg }}</p>-->
<!--          </div>-->
<!--          <h4>(三) 项目实施涵盖范围、实施规模、服务人群，创新之处等</h4>-->
<!--          <div class="one-e">-->
<!--            <p v-html="zData.prodemotwo">{{ zData.prodemotwo }}</p>-->
<!--          </div>-->
          <h3 class="title1" style="width:400px;float:right;margin-right:305px">
            五、经费预算 （{{yusuan}}）元
          </h3>
          <p style="clear:both"></p>
          <div id="one_e" v-html="zData.funds" style="margin-left:75px; width: 1081px">
            {{ zData.funds }}
          </div>
          <h3 class="title1" style="font-size: 20px">六、申报单位承诺</h3>
          <div class="one-e">
            <p>{{ msg }}</p>
          </div>
          <h3 class="title1" style="font-size: 20px;">七、项目主责单位意见</h3>
          <div class="xxxx" style="width: 300px;margin-top: 30px;position: relative;right: 15px;top: -39px;">
            <template>
              <el-upload class="upload-demo" :action="$upload" :on-preview="handlePreview" :on-success="successUpload" multiple :limit="10" :on-exceed="handleExceed" :file-list="dataFile" style="margin-left: 282px;">
              </el-upload>
            </template>
          </div>
        </div>
        <!--5个上传  -->
        <div class="upload_f_box">
          <template>
            <div class="options_box">
              <el-upload class="avatar-uploader" disabled :action="$upload" accept=".pdf" :show-file-list="false" style="position: relative">
                <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <p style="margin-bottom:10px;text-align:center;margin-top:18px;" v-if="filename.length">
                <el-tooltip class="item" effect="dark" placement="top" :content="filename">
                  <a :href="ruleForm.probook" target="_blank" style="width:100px;display:block;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;">
                    {{filename?filename:''}}</a>
                </el-tooltip>
              </p>
              <div class="filenames" v-if="filename">
                <a :href="fileurl" class="yulan" target="_blank" style="color:#409eff;">下载</a>
              </div>
              <p class="box1" style="font-weight:bold;">
                上传项目申报书
                <span style="font-size:10px;color:red;postion:relative;top:-3px;font-weight:bold">*</span>
              </p>
            </div>
            <!--文件上传-->
          </template>
          <template>
            <div class="options_box">
              <el-upload class="avatar-uploader" :action="$upload" accept=".pdf" :show-file-list="false" style="position: relative" disabled>
                <img v-if="imageUrl1" :src="imageUrl1" class="avatar" />
              </el-upload>
              <div v-if="filename1" style="text-align:center;margin-top:18px;margin-bottom:10px;">
                <p>
                  <el-tooltip class="item" effect="dark" :content="filename1" placement="top">
                    <a :href="ruleForm.fangan" target="_blank" style="width:100px;margin-left:40px;display:block;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;">
                      {{filename1?filename1:''}}</a>
                  </el-tooltip>
                </p>
              </div>
              <div style="text-align:center" v-if="filename1">
                <a :href="fileurl1" class="yulan" target="_blank" style="color:#409eff;">下载</a>
              </div>
              <div class="box1" style="font-weight:bold;">
                上传实施方案
                <span style="font-size:10px;color:red;postion:relative;top:-3px;font-weight:bold">*</span>
              </div>
            </div>
            <!--文件上传-->
          </template>
          <template>
            <div class="options_box">
              <el-upload class="avatar-uploader" accept=".pdf" :show-file-list="false" style="position: relative" disabled :action="$upload">
                <div style="position: absolute;z-index:9999;width:72px;left:52px;top:36px">
                  <el-progress v-if="uploadname[2] && uploadname[2] != 100" :text-inside="true" :stroke-width="16" :percentage="uploadname[2]" status="success"></el-progress>
                </div>
                <img v-if="imageUrl2" :src="imageUrl2" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <div v-if="filename2" style="margin-top:18px;">
                <div style="margin-bottom:10px">
                  <el-tooltip class="item" effect="dark" :content="filename2" placement="top">
                    <a :href="ruleForm.pifu" target="_blank" style="width:100px;margin-left:40px;white-space:nowrap;display:block;overflow:hidden;text-overflow: ellipsis;text-align:center">{{filename2?filename2:''}}</a>
                  </el-tooltip>
                </div>
                <div style="width:170px;text-align:center">
                  <a :href="fileurl2" class="yulan" target="_blank" style="color:#409eff;cursor:pointer">下载</a>
                </div>
              </div>
              <p class="box1" style="font-weight:bold;">上传立项批复文件</p>
            </div>
            <!--文件上传-->
          </template>
          <template>
            <div class="options_box">
              <el-upload class="avatar-uploader" accept=".pdf" disabled :show-file-list="false" style="position: relative" :action="$upload">
                <div style="position: absolute;z-index:9999;width:72px;left:52px;top:36px">
                  <el-progress v-if="uploadname[3] && uploadname[3] != 100" :text-inside="true" :stroke-width="16" :percentage="uploadname[3]" status="success"></el-progress>
                </div>
                <img v-if="imageUrl3" :src="imageUrl3" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <div v-if="filename3">
                <p style="margin-top:18px;margin-bottom:10px">
                  <el-tooltip class="item" effect="dark" :content="filename3" placement="top">
                    <a :href="ruleForm.pact" target="_blank" style="width:100px;margin-left:40px;display:block;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;">{{filename3?filename3:''}}</a>
                  </el-tooltip>
                </p>
                <div style="width:170px;text-align:center">
                  <a :href="fileurl3" class="yulan" target="_blank" style="color:#409eff;">下载</a>
                </div>
              </div>
              <p class="box1" style="font-weight:bold;">上传项目合同</p>
            </div>
            <!--文件上传-->
          </template>
          <template>
            <div class="options_box">
              <el-upload class="avatar-uploader" :action="$upload" accept=".pdf" :show-file-list="false" style="position: relative" disabled>
                <div style="position: absolute;z-index:9999;width:72px;left:53px;top:36px">
                  <el-progress v-if="uploadname[4] && uploadname[4] != 100" :text-inside="true" :stroke-width="16" :percentage="uploadname[4]" status="success"></el-progress>
                </div>
                <img v-if="imageUrl4" :src="imageUrl4" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <div class="box1" v-if="filename4">
                <p style="margin-bottom:10px">
                  <el-tooltip class="item" effect="dark" :content="filename4" placement="top">
                    <a :href="ruleForm.promise" target="_blank" style="width:100px;margin-left:12px;display:block;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;">{{filename4?filename4:''}}</a>
                  </el-tooltip>
                </p>
                <div style="text-align:center">
                  <a :href="fileurl4" class="yulan" target="_blank" style="color:#409eff;">下载</a>
                </div>
              </div>
              <p class="box1" style="font-weight:bold;">上传服务承诺书</p>
            </div>
          </template>
        </div>
      </div>
    </div>
    <!-- 项目执行信息html -->
    <div class="Project_Execution_box">
      <div class="boxx" v-if="sub == 2" :class="popupStatus == true ? 'fliter' : ''">
        <div class="excuteBox">
          <ul class="excute_list">
            <li>项目信息</li>
            <li>项目申报书</li>
            <li>实施方案</li>
            <li>立项批复文件</li>
            <li>项目合同</li>
            <li>服务承诺书</li>
            <li>中期评审材料</li>
            <li v-if="6 <= status && status <= 11">中期整改方案</li>
            <li>结项评审材料</li>
          </ul>
          <!-- 右边 -->
          <div class="excute_rt">
            <ul>
              <li>
                <span class="Project_Execution_name_text">项目名称：</span>
                <div class="text-div">{{ executio.name }}</div>
                <span style="display:line;width:10px;"></span>
                <span class="Project_Execution_name_text">执行机构：</span>
                <div class="text-div"> {{ executio.company }}</div>
              </li>
              <!-- 项目申报书 -->
              <li>
                <span>
                  <span :href="executio.probook" target="_blank">{{shili ? shili : "未上传"}}</span>
                  <a :href="executio.probook" target="_blank" class="yulan">{{
                shili.substring(shili.lastIndexOf(".") + 1) == "jpg" ||
                shili.substring(shili.lastIndexOf(".") + 1) == "pdf" ||
                shili.substring(shili.lastIndexOf(".") + 1) == "jpeg" ||
                shili.substring(shili.lastIndexOf(".") + 1) == "png"
                      ? "预览"
                      : "下载"
                  }}</a>
                </span>
              </li>
              <!-- 实施方案 -->
              <li>
                <span>
                  <span :href="executio.fangan" target="_blank">{{shili1 ? shili1 : "未上传"}}</span>
                  <a :href="executio.fangan" target="_blank" class="yulan">{{
                shili1.substring(shili1.lastIndexOf(".") + 1) == "jpg" ||
                shili1.substring(shili1.lastIndexOf(".") + 1) == "pdf" ||
                shili1.substring(shili1.lastIndexOf(".") + 1) == "jpeg" ||
                shili1.substring(shili1.lastIndexOf(".") + 1) == "png"
                      ? "预览"
                      : "下载"
                  }}</a>
                </span>
              </li>
              <!-- 立项批复文件 -->
              <li style="display: flex">
                <span v-if="shili2">
                  <span :href="executio.pifu ? executio.pifu : ''">{{
                    shili2 ? shili2 : "未上传"
                  }}</span>
                  <a :href="executio.pifu" target="_blank" class="yulan">{{
                shili2.substring(shili2.lastIndexOf(".") + 1) == "jpg" ||
                shili2.substring(shili2.lastIndexOf(".") + 1) == "pdf" ||
                shili2.substring(shili2.lastIndexOf(".") + 1) == "jpeg" ||
                shili2.substring(shili2.lastIndexOf(".") + 1) == "png"
                      ? "预览"
                      : "下载"
                  }}</a>
                </span>
                <span style="display: flex" v-if="!shili2">
                  <el-upload class="avatar-uploader" :action="$upload" :show-file-list="false" :http-request="upload_approval">
                    <el-button size="small" type="primary">点此上传</el-button>
                  </el-upload>
                </span>
                <el-button size="small" type="primary" style="margin-top: 10px" @click="deletepifu" v-if="show1">删除</el-button>
                <el-button size="small" type="primary" style="margin-top: 10px" @click="save" v-if="show1">提交</el-button>
              </li>
              <!-- 项目合同 -->
              <li style="display: flex">
                <span v-if="shili3">
                  <span :href="executio.pact ? executio.pact : ''" target="_blank">{{ shili3 ? shili3 : "未上传" }}</span>
                  <a :href="executio.pact" target="_blank" class="yulan">{{
                shili3.substring(shili3.lastIndexOf(".") + 1) == "jpg" ||
                shili3.substring(shili3.lastIndexOf(".") + 1) == "pdf" ||
                shili3.substring(shili3.lastIndexOf(".") + 1) == "jpeg" ||
                shili3.substring(shili3.lastIndexOf(".") + 1) == "png"
                      ? "预览"
                      : "下载"
                  }}</a>
                </span>
                <span style="display: flex" v-if="!shili3">
                  <!-- 更改项目合同:before-upload="beforeAvatarUpload" -->
                  <el-upload class="avatar-uploader" :action="$upload" :show-file-list="false" :on-success="handlesuccess1" :http-request="upload_contract" accept=".pdf">
                    <el-button size="small" type="primary">点此上传</el-button>
                  </el-upload>
                </span>
                <el-button size="small" type="primary" style="margin-top: 10px" @click="deleteHet" v-if="show2">删除</el-button>
                <el-button size="small" v-if="show2" style="margin-top: 10px" type="primary" @click="save1">提交</el-button>
              </li>
              <!-- 服务承诺书 -->
              <li style="display: flex">
                <span v-if="shili4">
                  <span :href="executio.promise ? executio.promise : ''" target="_blank">{{ shili4 ? shili4 : "未上传" }}</span>
                  <a :href="executio.promise" target="_blank" class="yulan">{{
                shili4.substring(shili4.lastIndexOf(".") + 1) == "jpg" ||
                shili4.substring(shili4.lastIndexOf(".") + 1) == "pdf" ||
                shili4.substring(shili4.lastIndexOf(".") + 1) == "jpeg" ||
                shili4.substring(shili4.lastIndexOf(".") + 1) == "png"
                      ? "预览"
                      : "下载"
                  }}</a>
                </span>
                <span style="display: flex" v-if="!shili4">
                  <el-upload class="avatar-uploader" :action="$upload" :show-file-list="false" :on-success="handlesuccess2" :http-request="upload_commitment">
                    <el-button size="small" type="primary">点此上传</el-button>
                  </el-upload>
                </span>

                <el-button size="small" type="primary" style="margin-top: 10px" @click="deleteP" v-if="show3">删除</el-button>
                <el-button size="small" v-if="show3" style="margin-top: 10px" type="primary" @click="save2">提交</el-button>
              </li>
              <!-- 中期评审材料 -->
              <li style="display: flex">
                <el-button size="small" style="float: left; margin-top: 10px" type="primary" @click="submit_mid">填写并提交</el-button>
                <el-button size="small" style="float: left; margin-top: 10px" type="primary" v-if="this.id" @click="excutes(id)">查看</el-button>&nbsp;
              </li>
              <!-- 中期整改方案 -->
              <li style="display: flex" v-if="6 <= status && status <= 11">
                <span v-if="shili9">
                  <span :href="center.rectifi ? center.rectifi : ''" target="_blank">{{ shili9 ? shili9 : "未上传" }}</span>
                  <a :href="center.rectifi" target="_blank" class="yulan">{{
                shili9.substring(shili9.lastIndexOf(".") + 1) == "jpg" ||
                shili9.substring(shili9.lastIndexOf(".") + 1) == "pdf" ||
                shili9.substring(shili9.lastIndexOf(".") + 1) == "jpeg" ||
                shili9.substring(shili9.lastIndexOf(".") + 1) == "png"
                      ? "预览"
                      : "下载"
                  }}</a>
                </span>
                <span style="display: flex" v-if="!shili9">
                  <el-upload class="avatar-uploader" :action="$upload" :show-file-list="false" :on-success="handlesuccess8" :before-upload="beforeAvatarUploadzq" :http-request="upload_approval_zg" accept=".doc,.docx,.pdf">
                    <el-button size="small" type="primary">点此上传</el-button>
                  </el-upload>
                </span>
                <el-button size="small" type="primary" style="margin-top: 10px" @click="deleteEit" v-if="show8">删除</el-button>
                <el-button size="small" v-if="show8" style="margin-top: 10px" type="primary" @click="save8">提交</el-button>
              </li>
              <!-- 结项评审材料 -->
              <li>
                <el-button size="small" style="float: left; margin-top: 10px" type="primary" @click="post_pro">填写并提交</el-button>
                <el-button size="small" type="primary" style="float: left; margin-top: 10px" v-if="this.id" @click="overs(id)">查看</el-button>&nbsp;
              </li>
            </ul>
          </div>
          <!--下边-->
          <div class="excute_tab">
            <div class="caption">
              <span @click="num = 0" :class="{ active: num == 0 }" style="cursor: pointer">月工作报表统计</span>
              <span @click="num = 1" :class="{ active: num == 1 }" style="cursor: pointer">优秀活动新闻稿</span>
              <div class="speed_box">
                <el-button type="text" v-show="num == 0" @click="dialogTableVisible = true" style="font-size: 22px">+月工作报表</el-button>
                <el-dialog title="上传月工作报表" :visible.sync="dialogTableVisible" @close="toclose">
                  <aside>
                    <div class="yuedu">
                      <label>一、项目名称:</label>
                      <el-input :disabled="true" v-model="zData.name" placeholder="请输入内容" style="width: 300px; margin-left: 10px"></el-input>
                    </div>
                    <div class="yuedu">
                      <label>二、机构名称:</label>
                      <el-input :disabled="true" v-model="zData.company" placeholder="请输入内容" style="width: 300px; margin-left: 10px"></el-input>
                    </div>
                    <div class="yuedu">
                      <label>三、日期选择:</label>
                      <div style="width: 305px; margin-left: 4px">
                        <el-date-picker v-model="month" type="month" format="yyyy-MM" value-format="timestamp" placeholder="选择日期时间" style="margin-left: 10px; margin-bottom: 10px"></el-date-picker>
                      </div>
                    </div>
                    <input v-model="editMouth_id" type="hidden">

                    <div style="margin-left: 35px">
                      <label>四、模板下载：</label>
                      <span style="position: relative; left: 19px;">
                        <a href="./npblic/工作月报表（模版）.docx" style="margin-right: 20px">工作月报表（模版）.DOC</a>
                        <a href="./npblic/工作月报表（模版）.docx" download style="margin-left: 8px">下载</a>
                      </span>
                    </div>
                    <div class="mid_box" style="
                        margin-bottom: 30px;
                        width: 708px;
                        margin-left: 35px;
                      ">
                      <label style="white-space: nowrap">五、上传电子版文件：</label>
                      <div class="xxxx" style="position: relative">
                        <template>
                          <el-upload class="upload-demo" :http-request="upload_worksheet" :action="$upload" :on-preview="handlePreview" :on-remove="handleRemove1" :on-success="successUploadTwo" :before-remove="beforeRemove" multiple :on-exceed="handleExceed1" :file-list="fileLists1" style="margin-left: 20px; margin-top: 10px" ref="dianzi" :title="filename">
                            <el-button size="small" type="primary" style="position: relative; top: -10px">上传文件</el-button>
                          </el-upload>
                        </template>
                      </div>
                    </div>
                    <el-button size="small" type="primary" @click="subBtn" style="display: block; margin: 0 auto">提交</el-button>
                  </aside>
                </el-dialog>
                <el-button type="text" v-show="num == 1" @click="dialogFormVisible = true" style="font-size: 22px">+新闻稿</el-button>
                <el-dialog title="添加新闻稿" :visible.sync="dialogFormVisible" @close="toclose">
                  <aside>
                    <div class="yuedu">
                      <label>一、项目名称:</label>
                      <el-input :disabled="true" v-model="zData.name" placeholder="请输入内容" style="width: 300px; margin-left: 10px"></el-input>
                    </div>
                    <div class="yuedu">
                      <label>二、机构名称:</label>
                      <el-input :disabled="true" v-model="zData.company" placeholder="请输入内容" style="width: 300px; margin-left: 10px"></el-input>
                    </div>
                    <div class="yuedu">
                      <label>三、日期选择:</label>
                      <el-date-picker v-model="month" type="date" value-format="timestamp" placeholder="选择日期时间" style="margin-left: 10px; margin-bottom: 10px"></el-date-picker>
                    </div>
                    <div class="yuedu" style="margin-left: 10px">
                      <label>四、模板下载：</label>
                      <span style="padding-top: 10px">
                        <span>
                          <a href="./npblic/新闻稿（模版）.docx">新闻稿（模版）.DOC</a>
                          &nbsp; &nbsp;
                          <a href="./npblic/新闻稿（模版）.docx" download>下载</a>
                        </span>
                      </span>
                    </div>
                    <div class="mid_box" style="width: 950px; margin-left: 33px">
                      <label>五、上传电子版新闻稿：</label>
                      <div class="xxxx" style="
                          margin-left: 29px;
                          margin-top: -1px;
                          margin-bottom: 64px;
                          width: 708px;
                          position: relative;
                        ">
                        <template>
                          <el-upload class="upload-demo" :action="$upload" :http-request="upload_news" :on-preview="handlePreview" :on-remove="handleRemove2" :on-success="successUploadThree" :before-remove="beforeRemove" multiple :on-exceed="handleExceed1" :file-list="fileLists2" ref="xinwen" :title="filename">
                            <el-button size="small" type="primary">上传文件</el-button>

                          </el-upload>
                        </template>
                      </div>
                    </div>
                    <el-button size="small" type="primary" @click="subsBun" style="display: block; margin: 0 auto">提交</el-button>
                  </aside>
                </el-dialog>
              </div>
            </div>

            <div class="excute_text">
              <div class="statistics" v-show="num == 0">
                <table style="position: relative; left: 45px">
                  <tr>
                    <th style="border-right: 1px solid white">月份</th>
                    <th style="border-right: 1px solid white">提交情况</th>
                    <th style="border-right: 1px solid white">月报文件</th>
                    <th style="border-right: 1px solid white">提交时间</th>
                    <th style="border-right: 1px solid white">操作</th>
                  </tr>
                  <template v-if="searchValue.length == 0">
                    <tr v-for="(info, index) in mont" :key="index" :class="{ on: index % 2 == 0, off: index % 2 != 0 }" class="tr">
                      <td>{{ info.month }}</td>
                      <td>{{ info.type }} <span v-if="info.status ==0">(已驳回)</span></td>

                      <td>

                        <div v-for="(item, index) in JSON.parse(info.elereport)" :key="index">
                          <div v-if="JSON.parse(info.elereport).length > 1" style="
                              display: flex;
                              flex-wrap: nowrap;

                            ">
                            <!-- {{item}} -->
                            <el-tooltip class="item" effect="dark" :content="item.name ? item.name : '未上传'" placement="top">
                              <a :href="item.url" target="view_window" style="
                                  width: 180px;
                                  display: block;
                                  white-space: nowrap;
                                  overflow: hidden;
                                  text-overflow: ellipsis;
                                ">{{ item.name }}</a>
                            </el-tooltip>

                            <a :href="item.url ? item.url : ''" target="view_window" style="width: 50px; color: #7471ef" v-if="info.elereport">下载</a>
                          </div>
                          <div v-else style="display: flex; flex-wrap: nowrap">

                            <el-tooltip class="item" effect="dark" :content="
                                JSON.parse(info.elereport)[0].names +
                                '.' +
                                JSON.parse(info.elereport)[0].extension
                              " placement="top">
                              <a :href="JSON.parse(info.elereport)[0].url" target="view_window" style="
                                  width: 180px;
                                  display: block;
                                  white-space: nowrap;
                                  overflow: hidden;
                                  text-overflow: ellipsis;
                                ">{{
                                  JSON.parse(info.elereport)[0].names +
                                  "." +
                                  JSON.parse(info.elereport)[0].extension
                                }}</a>
                            </el-tooltip>

                            <a :href="
                                info.elereport
                                  ? JSON.parse(info.elereport)[0].url
                                  : ''
                              " target="view_window" style="width: 50px; color: #7471ef" v-if="info.elereport">下载</a>
                          </div>
                        </div>

                      </td>
                      <td>{{ info.created_at }}</td>
                      <td>
                        <el-button type="text" @click="editMon(info)" v-show="info.status == 0">
                          修改
                        </el-button>
                      </td>
                    </tr>
                  </template>
                </table>
              </div>
              <div class="statistics" v-show="num == 1">
                <table class style="position: relative; left: 62px; table-layout: fixed">
                  <tr>
                    <th style="border-right: 1px solid white">项目名称</th>
                    <th style="border-right: 1px solid white">项目执行机构</th>
                    <th style="border-right: 1px solid white">文件名称</th>
                    <th>提交时间</th>
                  </tr>
                  <template v-if="searchValue.length == 0">

                    <tr class="tr" v-for="(info, index) in newss" :key="index" :class="{ on: index % 2 == 0, off: index % 2 != 0 }">
                      <td style="
                          width: 200px;
                          text-indent: 30px;
                          overflow: hidden;
                          white-space: nowrap;
                          text-overflow: ellipsis;
                        ">
                        <el-tooltip class="item" effect="dark" :content="zData.name1" placement="top">
                          <p style="
                              width: 170px;
                              white-space: nowrap;
                              text-indent: 30px;
                              overflow: hidden;
                              text-overflow: ellipsis;
                            ">
                            {{ zData.name1 }}
                          </p>
                        </el-tooltip>
                      </td>
                      <td>
                        <el-tooltip class="item" effect="dark" :content="zData.company" placement="top">
                          <p style="
                              width: 200px;
                              text-indent: 40px;
                              overflow: hidden;
                              white-space: nowrap;
                              text-overflow: ellipsis;
                            ">
                            {{ zData.company }}
                          </p>
                        </el-tooltip>
                      </td>
                      <td>

                        <div v-for="(item, index) in JSON.parse(info.elereport)" :key="index">
                          <div v-if="JSON.parse(info.elereport).length > 1" style="
                              display: flex;
                              flex-wrap: nowrap;

                            ">
                            <!-- {{item}} -->
                            <el-tooltip class="item" effect="dark" :content="item.name ? item.name : '未上传'" placement="top">
                              <a :href="item.url" target="view_window" style="
                                  width: 180px;
                                  display: block;
                                  white-space: nowrap;
                                  overflow: hidden;
                                  text-overflow: ellipsis;
                                ">{{ item.name }}</a>
                            </el-tooltip>

                            <a :href="item.url ? item.url : ''" target="view_window" style="width: 50px; color: #7471ef" v-if="info.elereport">下载</a>
                          </div>

                          <div v-else style="display: flex; flex-wrap: nowrap">

                            <el-tooltip class="item" effect="dark" :content="
                                JSON.parse(info.elereport)[0].names +
                                '.' +
                                JSON.parse(info.elereport)[0].extension
                              " placement="top">
                              <a :href="JSON.parse(info.elereport)[0].url" target="view_window" style="
                                  width: 180px;
                                  display: block;
                                  white-space: nowrap;
                                  overflow: hidden;
                                  text-overflow: ellipsis;
                                ">{{
                                  JSON.parse(info.elereport)[0].names +
                                  "." +
                                  JSON.parse(info.elereport)[0].extension
                                }}</a>
                            </el-tooltip>

                            <a :href="
                                info.elereport
                                  ? JSON.parse(info.elereport)[0].url
                                  : ''
                              " target="view_window" style="width: 50px; color: #7471ef" v-if="info.elereport">下载</a>
                          </div>
                        </div>
                      </td>
                      <td>{{ info.created_at }}</td>
                    </tr>
                  </template>
                </table>
              </div>
              <div class="monitor" v-show="num == 2">
                <table>
                  <tr>
                    <th>机构名称</th>
                    <td>{{ jiance.org_name }}</td>
                    <th>预计参与人数</th>
                    <td>{{ jiance.num }}</td>
                  </tr>
                  <tr>
                    <th>活动时间</th>
                    <td>{{ jiance.reserve }}</td>
                    <th>项目联系人</th>
                    <td>{{ jiance.linkman }}</td>
                  </tr>
                  <tr>
                    <th>活动名称</th>
                    <td>{{ jiance.active }}</td>
                    <th>联系方式</th>
                    <td>{{ jiance.tel }}</td>
                  </tr>
                  <tr>
                    <th>活动地点</th>
                    <td>{{ jiance.place }}</td>
                    <th>检查机构</th>
                    <td>{{ jiance.monitor }}</td>
                  </tr>
                  <tr>
                    <th>活动内容</th>
                    <td colspan="3">{{ jiance.detail }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <!--tab切换-->
        </div>
      </div>
    </div>
    <footer-nav class="footer"></footer-nav>
  </div>
</template>
<script>
  import HeaderNav from "../../components/HeaderNav";
  import FooterNav from "../../components/FooterNav";
  import AboutUs from "../../components/AboutUs";
  import ProjectBrief from "../../components/ProjectBrief";
  import ProjectAssessment from "../../components/ProjectAssessment";
  import ExistingBasis from "../../components/ExistingBasis";
  import MethodsWay from "../../components/MethodsWay";
  import scheduling from "../../components/Scheduling";
  import DesiredEffect from "../../components/DesiredEffect";
  import DivisionLabor from "../../components/DivisionLabor";
  import cover from "../../components/Cover";
  import RichTextOne from "../../components/RichTextOne";
  var preD = function (e) {
    e.preventDefault();
  };
  export default {
    components: {
      HeaderNav,
      FooterNav,
      AboutUs,
      ProjectBrief,
      ProjectAssessment,
      ExistingBasis,
      MethodsWay,
      scheduling,
      DesiredEffect,
      DivisionLabor,
      cover,
      RichTextOne
    },
    props: {},
    data() {
      return {
        editMouth_id: '',
        // 等待
        box_loading: true,
        yhyusuan: "",
        yusuan: "",
        review_jx: "",
        review_my: "",
        review_zq: "",
        review_my_zq: "",
        review_my_zq_url: "",
        review_jx_url: "",
        review_my_url: "",
        review_zq_url: "",
        xinweiurl: "",
        dianziurl: "",
        fileLists2: [],
        fileLists1: [],
        ifupdate: false,
        show1: false,
        show2: false,
        show3: false,
        show8: false,
        show20: false,
        show21: false,
        errorMsg: "",
        center: [],
        ruleForm: {
          name: "",
          company: "",
          tid: "",
          rid: "",
          first_level: "",
          secondary: "",
          fieldeara: "",
          attribute: "",
          aterm: "",
          fterm: "",
          postaladdress: "",
          postalcode: "",
          pmail: "",
          fax_tel: "",
          plegal: "",
          plcode: "",
          pname: "",
          poster: "",
          poffice_tel: "",
          aphone: "",
          cname: "",
          cpost: "",
          coffice_tel: "",
          cphone: "",
          prespo: "",
          respoadd: "",
          respopcode: "",
          respomail: "",
          respophone: "",
          respopname: "",
          respopost: "",
          respoophone: "",
          respoptel: "",
          respocname: "",
          respocpost: "",
          respocophone: "",
          respoctel: "",
          decldes: "",
          prodes: "",
          party_id: '',
          prodemo: "",
          prodemojc: "",
          prodemotj: "",
          prodemojd: "",
          prodemoxg: "",
          prodemofg: "",
          prodemotwo: "",
          funds: "",
          proimages: "",
          status: 0,
          protime: ""
        },
        rules: {
          name: [{
            required: true,
            message: "请输入项目名称",
            trigger: "blur"
          }],
          tid: [{
            required: true,
            message: "请选择项目类型",
            trigger: "change"
          }],
          rid: [{
            required: true,
            message: "请选择项目落地区域",
            trigger: "change"
          }],
          company: [{
            required: true,
            message: "请输入项目申报单位",
            trigger: "blur"
          }],
          first_level: [{
            required: true,
            message: "请输入一级项目方向",
            trigger: "blur"
          }],
          secondary: [{
            required: true,
            message: "请输入二级项目方向",
            trigger: "blur"
          }],
          fieldeara: [{
            required: true,
            message: "请输入三级项目方向",
            trigger: "blur"
          }],
          attribute: [{
            required: true,
            message: "请输入项目服务领域",
            trigger: "blur"
          }],
          postaladdress: [{
            required: true,
            message: "请输入通讯地址",
            trigger: "blur"
          }],
          postalcode: [{
            required: true,
            message: "请输入邮政编码",
            trigger: "blur"
          }],
          pmail: [{
            required: true,
            message: "请输入电子邮箱",
            trigger: "blur"
          }],
          plegal: [{
            required: true,
            message: "请输入法定代表人",
            trigger: "blur"
          }],
          plcode: [{
            required: true,
            message: "请输入法人代码",
            trigger: "blur"
          }],
          pname: [{
            required: true,
            message: "请输入负责人姓名",
            trigger: "blur"
          }],
          poster: [{
            required: true,
            message: "请输入职务",
            trigger: "blur"
          }],
          poffice_tel: [{
            required: true,
            message: "请输入办公电话",
            trigger: "blur"
          }],
          aphone: [{
            required: true,
            message: "请输入手机",
            trigger: "blur"
          }],
          cname: [{
            required: true,
            message: "请输入联系人姓名",
            trigger: "blur"
          }],
          cpost: [{
            required: true,
            message: "请输入职务",
            trigger: "blur"
          }],
          coffice_tel: [{
            required: true,
            message: "请输入办公电话",
            trigger: "blur"
          }],
          cphone: [{
            required: true,
            message: "请输入手机",
            trigger: "blur"
          }]

        },
        rules1: {
          prespo: [{
            required: true,
            message: "请输入项目主责单位",
            trigger: "blur"
          }],
          respoadd: [{
            required: true,
            message: "请输入通讯地址",
            trigger: "blur"
          }],
          respopcode: [{
            required: true,
            message: "请输入邮政编码",
            trigger: "blur"
          }],
          respomail: [{
              required: true, //是否必填
              message: "请输入邮箱地址", //错误提示信息
              trigger: "blur" //检验方式（blur为鼠标点击其他地方，）
            },
            {
              type: "email", //要检验的类型（number，email，date等）
              message: "请输入正确的邮箱地址",
              trigger: ["blur", "change"]
            }
          ],
          respopname: [{
            required: true,
            message: "请输入负责人姓名",
            trigger: "blur"
          }],
          respopost: [{
            required: true,
            message: "请输入负责人职务",
            trigger: "blur"
          }],
          respoophone: [{
            required: true,
            message: "请输入负责人办公电话",
            trigger: "blur"
          }],

          respocname: [{
            required: true,
            message: "请输入联系人姓名",
            trigger: "blur"
          }],
          respocpost: [{
            required: true,
            message: "请输入联系人职务",
            trigger: "blur"
          }],
          respocophone: [{
            required: true,
            message: "请输入联系人办公电话",
            trigger: "blur"
          }],

          respoptel: [{
              required: true,
              message: "请输入手机号",
              trigger: "blur"
            },
            {
              pattern: /^1([38][0-9]|4[579]|5[0-3,5-9]|6[0-9]|7[0135678]|9[0-9])\d{8}$/, //可以写正则表达式呦呦呦
              message: "请输入正确的手机号",
              trigger: "change"
            }
          ],
          respoctel: [{
              required: true,
              message: "请输入手机号",
              trigger: "blur"
            },
            {
              pattern: /^1([38][0-9]|4[579]|5[0-3,5-9]|6[0-9]|7[0135678]|9[0-9])\d{8}$/, //可以写正则表达式呦呦呦
              message: "请输入正确的手机号",
              trigger: "change"
            }
          ]
        },
        ruleForm1: {
          prespo: "",
          respoadd: "",
          respopcode: "",
          respomail: "",
          respophone: "",
          respopname: "",
          respopost: "",
          respoophone: "",
          respoptel: "",
          respocname: "",
          respocpost: "",
          respocophone: "",
          respoctel: ""
        },
        shili: "",
        shili1: "",
        shili3: "",
        shili2: "",
        shili4: "",
        shili5: "",
        shili6: "",
        shili7: "",
        shili8: "",
        shili9: "",
        shili20: "",
        shili21: "",
        convers: [],
        num: 0,
        index_num: 2,
        sub: 0,
        imgUrl1: {
          tg: require("../../../static/img/tg.png"),
          btg: require("../../../static/img/btg.png"),
          shz: require("../../../static/img/shz.png"),
          zxz: require("../../../static/img/zxz.png"),
          sx0: require("../../../static/img/sx0.png"),
          sx1: require("../../../static/img/sx1.png"),
          d0: require("../../../static/img/d0.png"),
          d1: require("../../../static/img/d1.png"),
          xd: require("../../../static/img/xd.png")
        },
        msg: "我们确认项目申报内容的真实性,并愿意承担相应的责任",
        state: 0,
        zt: 2,
        popupStatus: false,
        text: [
          "第一步：填写并提交项目申报书",
          "第二步：线上初筛审核",
          "第三步：项目初筛结果查询",
          "第四步：线下立项评审",
          "第五步：立项结果查询"
        ],
        zData: [],
        zDate: [],
        dataFile: '',
        id: Number,
        fileName: '',
        dialogTableVisible: false,
        dialogFormVisible: false,
        form: {
          name: "",
          region: "",
          date1: "",
          date2: "",
          delivery: false,
          type: [],
          resource: "",
          desc: ""
        },
        formLabelWidth: "120px",
        name: " ",
        imageUrl: " ",

        fileLists: [],
        month: "",
        executio: '',
        pop: false,
        linkData: "",
        jiance: '',
        mont: '',
        newss: '',
        searchValue: [],
        proinfo: true,
        fileid: 0,
        filename: "",
        fileurl: "",
        status: false,
        progress: 0,
        index_num: 2,
        sub: 0,
        bgData: '',
        initialTextVal: "",
        initialText: "",
        aboutUsText: "<h1>aaa</h1>",
        aboutUsVal: "<h1>aaa</h1>",
        projectBriefVal: "",
        projectBriefText: "",
        projectAssessmentVal: "",
        projectAssessmentText: "",
        existingBasisVal: "",
        existingBasisText: "",
        methodsWayVal: "",
        methodsWayText: "",
        schedulingVal: "",
        schedulingText: "",
        desiredEffectVal: "",
        desiredEffectText: "",
        divisionLaborVal: "",
        divisionLaborText: "",
        coverVal: "",
        coverText: "",
        thff: true,
        imgUrl: {
          bg0: require("../../../static/img/bg0.png"),
          bg1: require("../../../static/img/bg1.png"),
          xa: require("../../../static/img/xa.png")
        },
        fileLists: [],
        popupStatus: false,
        first_levels: [],
        types: [],
        area: [],
        name: "",
        company: "",
        tid: "",
        rid: "",
        first_level: "",
        secondary: "",
        fieldeara: "",
        attribute: "",
        aterm1: "",
        fterm: "",
        postaladdress: "",
        postalcode: "",
        pmail: "",
        fax_tel: "",
        plegal: "",
        plcode: "",
        pname: "",
        poster: "",
        poffice_tel: "",
        aphone: "",
        cname: "",
        cpost: "",
        coffice_tel: "",
        cphone: "",
        prespo: "",
        respoadd: "",
        respopcode: "",
        respomail: "",
        respophone: "",
        respoctel: "",
        respopname: "",
        respopost: "",
        respoophone: "",
        respoptel: "",
        respocname: "",
        respocpost: "",
        respocophone: "",
        decldes: "",
        prodes: "",
        prodemo: "",
        prodemojc: "",
        prodemotj: "",
        prodemojd: "",
        prodemoxg: "",
        prodemofg: "",
        prodemotwo: "",
        funds: "",
        proimages: "",
        subStatus: 0,
        picture: [],
        pid: 0,
        imgs: [],
        imageUrl: "",
        imageUrl1: "",
        imageUrl2: "",
        imageUrl3: "",
        imageUrl4: "",
        idProject: "",
        fileurl: "",
        fileurl1: "",
        fileurl2: "",
        fileurl3: "",
        fileurl4: "",
        filename: "",
        filename1: "",
        filename2: "",
        filename3: "",
        filename4: "",
        sub1: 0,
        project_id: 0,
        previewinfo: {},
        uploadname: ["", "", "", "", "", "", ""],
        shili2url: "",
        shili3url: "",
        shili4url: '',
        shili8url: '',
        shili20url: '',
        shili21url: '',
        down20: false,
        down21: false,
        code: '',
      };
    },
    computed: {
      arr: function () {}
    },
    watch: {
      popupStatus(val) {
        if (val) {
          document.body.style.overflow = "hidden";
          document.addEventListener("touchmove", preD, {
            passive: false
          }); /** 禁止页面滑动 */
        } else {
          document.body.style.overflow = ""; /** 出现滚动条 */
          document.removeEventListener("touchmove", preD, {
            passive: false
          });
        }
      }
    },
    methods: {

      //修改月报告
      editMon(info) {
        var date = new Date(info.month)
        this.$set(this, "month", date.getTime())
        this.editMouth_id = info.id
        this.dialogTableVisible = true
      },

      // 立项批复文件上传
      upload_approval(f) {
        let fileName = f.file.name;
        let uid = f.file.uid;
        let pos = fileName.lastIndexOf(".");
        let lastName = fileName.substring(pos, fileName.length);
        if (lastName.toLowerCase() == ".pdf") {
          let formdata = new FormData();
          formdata.append("file", f.file);
          this.$axios({
              url: "v1/file/files",
              method: "post",
              data: formdata,
              nol: 45,
              headers: {
                "Content-Type": "multipart/form-data"
              },
              onUploadProgress: progressEvent => {
                this.$set(
                  this.uploadname,
                  1,
                  parseInt((progressEvent.loaded / progressEvent.total) * 100)
                );
              }
            })
            .then(res => {
              if (res.data.code == 200) {
                if (this.uploadname[1] === 100) {
                  this.handleAvatarSuccess1(res.data.data, f.file.name);
                  this.handlesuccess(res.data)
                }
              } else {
                this.$alert("上传的实施方案文件上传失败,请修改文件名长度后重新上传", "提示", {
                  confirmButtonText: "确定",
                  callback: action => {}
                });
                return false;
              }
            })
            .then(error => {});
          return;
        } else {
          this.$message.error("文件必须为pdf 类型");
        }
      },
      upload_approval_zg(f) {
        let fileName = f.file.name;
        let uid = f.file.uid;
        let pos = fileName.lastIndexOf(".");
        let lastName = fileName.substring(pos, fileName.length);
        if (lastName.toLowerCase() == ".pdf") {
          // 创建空对像实例
          let formdata = new FormData();
          formdata.append("file", f.file);
          this.$axios({
              url: "v1/file/files",
              method: "post",
              data: formdata,
              nol: 45,
              headers: {
                "Content-Type": "multipart/form-data"
              },
              onUploadProgress: progressEvent => {
                this.$set(
                  this.uploadname,
                  1,
                  parseInt((progressEvent.loaded / progressEvent.total) * 100)
                );
              }
            })
            .then(res => {
              if (res.data.code == 200) {
                if (this.uploadname[1] === 100) {
                  this.handleAvatarSuccess1(res.data.data, f.file.name);
                  this.handlesuccess8(res.data)
                }
              } else {
                this.$alert("上传的实施方案文件上传失败,请修改文件名长度后重新上传", "提示", {
                  confirmButtonText: "确定",
                  callback: action => {}
                });
                return false;
              }
            })
            .then(error => {});
          return;
        } else {
          this.$message.error("文件必须为pdf 类型");
        }
      },
      //上传月工作表电子版
      upload_worksheet(f) {
        let fileName = f.file.name;
        let uid = f.file.uid;
        let pos = fileName.lastIndexOf(".");
        let lastName = fileName.substring(pos, fileName.length);
        if (lastName.toLowerCase() == ".pdf" || lastName.toLowerCase() == ".doc" || lastName.toLowerCase() == ".docx") {
          let formdata = new FormData();
          formdata.append("file", f.file);
          this.$axios({
              url: "v1/file/files",
              method: "post",
              data: formdata,
              nol: 45,
              headers: {
                "Content-Type": "multipart/form-data"
              },
              onUploadProgress: progressEvent => {
                this.$set(
                  this.uploadname,
                  1,
                  parseInt((progressEvent.loaded / progressEvent.total) * 100)
                );
              }
            })
            .then(res => {
              if (res.data.code == 200) {
                if (this.uploadname[1] === 100) {
                  this.handleAvatarSuccess1(res.data.data, f.file.name);
                  this.successUploadTwo(res.data)
                }
              } else {
                this.$alert("上传的实施方案文件上传失败,请修改文件名长度后重新上传", "提示", {
                  confirmButtonText: "确定",
                  callback: action => {}
                });
                return false;
              }
            })
            .then(error => {});
        } else {
          this.$message.error("文件必须为pdf类型，或者word类型");
        }
      },
      // 上传新闻稿
      upload_news(f) {
        let fileName = f.file.name;
        let uid = f.file.uid;
        let pos = fileName.lastIndexOf(".");
        let lastName = fileName.substring(pos, fileName.length);
        if (lastName.toLowerCase() == ".pdf" || lastName.toLowerCase() == ".doc" || lastName.toLowerCase() == ".docx") {
          // 创建空对像实例
          let formdata = new FormData();
          formdata.append("file", f.file);
          this.$axios({
              url: "v1/file/files",
              method: "post",
              data: formdata,
              nol: 45,
              headers: {
                "Content-Type": "multipart/form-data"
              },
              onUploadProgress: progressEvent => {
                this.$set(
                  this.uploadname,
                  1,
                  parseInt((progressEvent.loaded / progressEvent.total) * 100)
                );
              }
            })
            .then(res => {
              if (res.data.code == 200) {
                if (this.uploadname[1] === 100) {
                  this.handleAvatarSuccess1(res.data.data, f.file.name);
                  this.successUploadThree(res.data)
                }
              } else {
                this.$alert("上传的实施方案文件上传失败,请修改文件名长度后重新上传", "提示", {
                  confirmButtonText: "确定",
                  callback: action => {}
                });
                return false;
              }
            })
            .catch(error => {});
        } else {
          this.$message.error("文件必须为pdf类型，或者word类型");
          return
        }

      },
      // 项目合同上传
      upload_contract(f) {
        let fileName = f.file.name;
        let uid = f.file.uid;
        let pos = fileName.lastIndexOf(".");
        let lastName = fileName.substring(pos, fileName.length);
        if (lastName.toLowerCase() == ".pdf") {
          // 创建空对像实例
          let formdata = new FormData();
          formdata.append("file", f.file);
          this.$axios({
              url: "v1/file/files",
              method: "post",
              data: formdata,
              nol: 45,
              headers: {
                "Content-Type": "multipart/form-data"
              },
              onUploadProgress: progressEvent => {
                this.$set(
                  this.uploadname,
                  1,
                  parseInt((progressEvent.loaded / progressEvent.total) * 100)
                );
              }
            })
            .then(res => {
              if (res.data.code == 200) {
                if (this.uploadname[1] === 100) {
                  this.handleAvatarSuccess1(res.data.data, f.file.name);
                  this.handlesuccess1(res.data)
                }
              } else {
                this.$alert("上传的实施方案文件上传失败,请修改文件名长度后重新上传", "提示", {
                  confirmButtonText: "确定",
                  callback: action => {}
                });
                return false;
              }
            })
            .then(error => {});
          return;
        } else {
          this.$message.error("文件必须为pdf 类型");
        }
      },
      //服务承诺书上传
      upload_commitment(f) {
        let fileName = f.file.name;
        let uid = f.file.uid;
        let pos = fileName.lastIndexOf(".");
        let lastName = fileName.substring(pos, fileName.length);
        if (lastName.toLowerCase() == ".pdf") {
          let formdata = new FormData();
          formdata.append("file", f.file);
          this.$axios({
              url: "v1/file/files",
              method: "post",
              data: formdata,
              nol: 45,
              headers: {
                "Content-Type": "multipart/form-data"
              },
              onUploadProgress: progressEvent => {
                this.$set(
                  this.uploadname,
                  1,
                  parseInt((progressEvent.loaded / progressEvent.total) * 100)
                );
              }
            })
            .then(res => {
              if (res.data.code == 200) {
                if (this.uploadname[1] === 100) {
                  this.handleAvatarSuccess1(res.data.data, f.file.name);
                  this.handlesuccess2(res.data)
                }
              } else {
                this.$alert("上传的实施方案文件上传失败,请修改文件名长度后重新上传", "提示", {
                  confirmButtonText: "确定",
                  callback: action => {}
                });
                return false;
              }
            })
            .then(error => {});
          return;
        } else {
          this.$message.error("文件必须为pdf 类型");
        }
      },
      handlesuccess(e) {
        this.shili2 = e.data.name
        this.shili2url = e.data.url
        this.show1 = true
        this.executio.pifu = e.data.url
      },
      handlesuccess1(e) {
        this.shili3 = e.data.name
        this.shili3url = e.data.url
        this.show2 = true
        this.executio.pact = e.data.url
      },
      handlesuccess2(e) {
        this.shili4 = e.data.name

        this.shili4url = e.data.url
        this.show3 = true
        this.executio.promise = e.data.url
      },
      handlesuccess8(e) {
        this.shili9 = e.data.name
        this.shili8url = e.data.url
        this.show8 = true
      },
      handlesuccess20(e) {
        this.shili20 = e.data.name
        this.shili20url = e.data.url
        this.show20 = true
      },
      handlesuccess21(e) {
        this.shili21 = e.data.name
        this.shili21url = e.data.url
        this.show21 = true
      },
      deleteP() {
        this.shili4 = ''
        this.shili4url = ''
        this.show3 = false
      },
      deletepifu() {
        this.shili2 = ''
        this.shili2url = ''
        this.show1 = false
      },
      deleteHet() {
        this.shili3 = ''
        this.shili3url = ''
        this.show2 = false
      },
      deleteEit() {
        this.shili9 = ''
        this.shili8url = ''
        this.show8 = false
      },
      delete20() {
        this.shili20 = ''
        this.shili20url = ''
        this.show20 = false
      },
      delete21() {
        this.shili21 = ''
        this.shili21url = ''
        this.show21 = false
      },
      save() {
        let t = this
        t.$axios({
            url: "v1/fei-project/safefile",
            method: "post",
            data: {
              project_id: t.id,
              pifu: t.shili2url
            },
            headers: {
              "Content-Type": "multipart/form-data"
            },
          })
          .then(res => {
            if (res.data.code == 200) {
              if (res.data.data.code == 400) {
                this.$alert(
                  "保存失败",
                  "提示", {
                    confirmButtonText: "确定",
                    callback: action => {}
                  }
                );
                return false;
              } else {
                t.show1 = false
              }
            } else {
              this.$alert(
                "保存失败",
                "提示", {
                  confirmButtonText: "确定",
                  callback: action => {}
                }
              );
              return false;
            }

          })
      },
      save1() {
        let t = this
        this.$http({
          method: 'post',
          url: 'v1/fei-project/safefile',
          data: {
            project_id: t.id,
            pact: t.shili3url
          }
        }).then((res) => {
          if (res.data.code == 200) {
            if (res.data.data.code == 400) {
              this.$alert(
                "保存失败",
                "提示", {
                  confirmButtonText: "确定",
                  callback: action => {}
                }
              );
              return false;
            } else {
              t.show2 = false
            }
          } else {
            this.$alert(
              "保存失败",
              "提示", {
                confirmButtonText: "确定",
                callback: action => {}
              }
            );
            return false;
          }
        })

      },
      save2() {
        let t = this
        t.$axios({
            url: "v1/fei-project/safefile",
            method: "post",
            data: {
              project_id: t.id,
              promise: t.shili4url
            },
            headers: {
              "Content-Type": "multipart/form-data"
            },
          })
          .then(res => {
            if (res.data.code == 200) {
              if (res.data.data.code == 400) {
                this.$alert(
                  "保存失败",
                  "提示", {
                    confirmButtonText: "确定",
                    callback: action => {}
                  }
                );
                return false;
              } else {
                t.show3 = false
              }
            } else {
              this.$alert(
                "保存失败",
                "提示", {
                  confirmButtonText: "确定",
                  callback: action => {}
                }
              );
              return false;
            }

          })
      },
      save8() {
        let t = this
        t.$axios({
            url: "v1/fei-project/rectifi",
            method: "post",
            data: {
              project_id: t.id,
              rectifi: t.shili8url
            },
            headers: {
              "Content-Type": "multipart/form-data"
            },
          })
          .then(res => {

            if (res.data.code == 200) {
              if (res.data.data.code == 400) {
                this.$alert(
                  "当前状态不允许上传文件,保存失败",
                  "提示", {
                    confirmButtonText: "确定",
                    callback: action => {}
                  }
                );
                return false;
              } else {
                t.show8 = false
              }
            } else {
              this.$alert(
                "当前项目为提交,保存失败",
                "提示", {
                  confirmButtonText: "确定",
                  callback: action => {}
                }
              );
              return false;
            }

          })
      },
      save20() {
        let t = this
        this.$confirm("此操作将保存提交当前上传的文件, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          t.$axios({
              url: "v1/fei-project/pro-en",
              method: "post",
              data: {
                project_id: t.id,
                declare: JSON.stringify([{
                  name: t.shili20,
                  url: t.shili20url
                }])
              },
              headers: {
                "Content-Type": "multipart/form-data"
              },
            })
            .then(res => {
              if (res.data.code == 200) {
                t.down20 = true;
                if (res.data.data.code == 400) {
                  this.$alert(
                    "当前状态不允许上传文件,保存失败",
                    "提示", {
                      confirmButtonText: "确定",
                      callback: action => {}
                    }
                  );
                  return false;
                } else {
                  t.show20 = false
                }
              } else {
                this.$alert(
                  "当前项目为提交,保存失败",
                  "提示", {
                    confirmButtonText: "确定",
                    callback: action => {}
                  }
                );
                return false;
              }

            })
        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消提交"
          });
        });

      },
      save21() {
        let t = this
        this.$confirm("此操作将保存提交当前上传的文件, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          t.$axios({
              url: "v1/fei-project/pro-en",
              method: "post",
              data: {
                project_id: t.id,
                implementation: JSON.stringify([{
                  name: t.shili21,
                  url: t.shili21url
                }])
              },
              headers: {
                "Content-Type": "multipart/form-data"
              },
            })
            .then(res => {

              if (res.data.code == 200) {
                t.down21 = true;
                if (res.data.data.code == 400) {
                  this.$alert(
                    "当前状态不允许上传文件,保存失败",
                    "提示", {
                      confirmButtonText: "确定",
                      callback: action => {}
                    }
                  );
                  return false;
                } else {
                  t.show21 = false
                }
              } else {
                this.$alert(
                  "当前项目为提交,保存失败",
                  "提示", {
                    confirmButtonText: "确定",
                    callback: action => {}
                  }
                );
                return false;
              }

            })
        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消提交"
          });
        });

      },
      uploadfile(f) {
        let formdata = new FormData();
        formdata.append("file", f.file);
        this.$axios({
            url: "v1/file/files",
            method: "post",
            data: formdata,
            nol: 45,
            headers: {
              "Content-Type": "multipart/form-data"
            },
            onUploadProgress: progressEvent => {
              this.$set(
                this.uploadname,
                0,
                parseInt((progressEvent.loaded / progressEvent.total) * 100)
              );

            }
          })
          .then(res => {
            if (res.data.data.code == 200) {
              if (this.uploadname[0] === 100) {
                this.handleAvatarSuccess(res.data.data, f.file.name);
              }
            } else {
              this.$alert(
                "上传的项目申报书文件上传失败,请修改文件名长度后重新上传",
                "提示", {
                  confirmButtonText: "确定",
                  callback: action => {}
                }
              );
              return false;
            }
          })
          .then(error => {
            // console.log(error);(error);
          });
        return;
      },
      uploadfile1(f) {
        let formdata = new FormData();
        formdata.append("file", f.file);
        this.$axios({
            url: "v1/file/files",
            method: "post",
            data: formdata,
            nol: 45,
            headers: {
              "Content-Type": "multipart/form-data"
            },
            onUploadProgress: progressEvent => {
              this.$set(
                this.uploadname,
                1,
                parseInt((progressEvent.loaded / progressEvent.total) * 100)
              );
            }
          })
          .then(res => {
            if (res.data.data.code == 200) {
              if (this.uploadname[1] === 100) {

                this.handleAvatarSuccess1(res.data.data, f.file.name);

              }
            } else {
              this.$alert(
                "上传的实施方案文件上传失败,请修改文件名长度后重新上传",
                "提示", {
                  confirmButtonText: "确定",
                  callback: action => {}
                }
              );
              return false;
            }
            // this.imageUrl = res.data.data
          })
          .then(error => {
            // console.log(error);(error);
          });
        return;
      },
      uploadfile2(f) {

        let formdata = new FormData();
        formdata.append("file", f.file);
        this.$axios({
            url: "v1/file/files",
            method: "post",
            data: formdata,
            nol: 45,
            headers: {
              "Content-Type": "multipart/form-data"
            },
            onUploadProgress: progressEvent => {
              this.$set(
                this.uploadname,
                2,
                parseInt((progressEvent.loaded / progressEvent.total) * 100)
              );

            }
          })
          .then(res => {

            if (res.data.data.code == 200) {
              if (this.uploadname[2] === 100) {

                this.handleAvatarSuccess2(res.data.data, f.file.name);

              }
            } else {
              this.$alert(
                "上传的立项批复文件上传失败,请修改文件名长度后重新上传",
                "提示", {
                  confirmButtonText: "确定",
                  callback: action => {}
                }
              );
              return false;
            }
          })
          .then(error => {
            // console.log(error);(error);
          });
        return;
      },
      uploadfile3(f) {
        let formdata = new FormData();
        formdata.append("file", f.file);
        this.$axios({
            url: "v1/file/files",
            method: "post",
            data: formdata,
            nol: 45,
            headers: {
              "Content-Type": "multipart/form-data"
            },
            onUploadProgress: progressEvent => {
              this.$set(
                this.uploadname,
                3,
                parseInt((progressEvent.loaded / progressEvent.total) * 100)
              );
            }
          })
          .then(res => {
            if (res.data.data.code == 200) {
              if (this.uploadname[3] === 100) {
                this.handleAvatarSuccess3(res.data.data, f.file.name);
              }
            } else {
              this.$alert(
                "上传的项目合同文件上传失败,请修改文件名长度后重新上传",
                "提示", {
                  confirmButtonText: "确定",
                  callback: action => {}
                }
              );
              return false;
            }
          })
          .then(error => {
            // console.log(error);(error);
          });
        return;
      },
      uploadfile4(f) {
        let formdata = new FormData();
        formdata.append("file", f.file);
        this.$axios({
            url: "v1/file/files",
            method: "post",
            data: formdata,
            nol: 45,
            headers: {
              "Content-Type": "multipart/form-data"
            },
            onUploadProgress: progressEvent => {
              this.$set(
                this.uploadname,
                4,
                parseInt((progressEvent.loaded / progressEvent.total) * 100)
              );
            }
          })
          .then(res => {
            if (res.data.data.code == 200) {
              if (this.uploadname[4] === 100) {

                this.handleAvatarSuccess4(res.data.data, f.file.name);

              }
            } else {
              this.$alert(
                "上传的服务承诺书文件上传失败,请修改文件名长度后重新上传",
                "提示", {
                  confirmButtonText: "确定",
                  callback: action => {}
                }
              );
              return false;
            }
            // this.imageUrl = res.data.data
          })
          .then(error => {
            // console.log(error);(error);
          });
        return;
      },
      uploadfile20(f) {
        let formdata = new FormData();
        let _this = this
        formdata.append("file", f.file);
        this.$axios({
            url: "v1/file/files",
            method: "post",
            data: formdata,
            nol: 45,
            headers: {
              "Content-Type": "multipart/form-data"
            },
            onUploadProgress: progressEvent => {
              this.$set(
                this.uploadname,
                2,
                parseInt((progressEvent.loaded / progressEvent.total) * 100)
              );

            }
          })
          .then(res => {
            _this.shili20 = res.data.data.name
            _this.shili20url = res.data.data.url
            _this.show20 = true
            if (_this.shili20) {
              this.hz = this.shili20.lastIndexOf(".") + 1;
              if (this.hz > 12) {
                this.shili20 = this.shili20.substr(0, 12) + "... .pdf"
              }
            }

          })
          .then(error => {
            // console.log(error);(error);
          });
        return;
      },
      uploadfile21(f) {
        let formdata = new FormData();
        let _this = this
        formdata.append("file", f.file);
        this.$axios({
            url: "v1/file/files",
            method: "post",
            data: formdata,
            nol: 45,
            headers: {
              "Content-Type": "multipart/form-data"
            },
            onUploadProgress: progressEvent => {
              this.$set(
                this.uploadname,
                2,
                parseInt((progressEvent.loaded / progressEvent.total) * 100)
              );

            }
          })
          .then(res => {
            _this.shili21 = res.data.data.name
            _this.shili21url = res.data.data.url
            _this.show21 = true
            if (_this.shili21) {
              this.hz = this.shili21.lastIndexOf(".") + 1;
              if (this.hz > 12) {
                this.shili21 = this.shili21.substr(0, 12) + "... .pdf"
              }
            }

          })
          .then(error => {
            // console.log(error);(error);
          });
        return;
      },
      del() {
        this.filename = "";
        this.imageUrl = "";
        this.ruleForm.probook = "";
      },
      del1() {
        this.filename1 = "";
        this.imageUrl1 = "";
        this.ruleForm.fangan = "";
      },
      del2() {
        this.filename2 = "";
        this.imageUrl2 = "";
        this.ruleForm.pifu = "";
      },
      del3() {
        this.filename3 = "";
        this.imageUrl3 = "";
        this.ruleForm.pact = "";
      },
      del4() {
        this.filename4 = "";
        this.imageUrl4 = "";
        this.ruleForm.promise = "";
      },
      yulana(file) {
        window.open(file.url);
        return;
      },
      yulana1(file) {
        window.open(file.url);
        return;
      },
      change(e) {
        this.tid = e;
      },
      change1(e) {
        this.rid = e;
      },
      change2(e) {
        this.first_level = e;
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      thf() {
        this.thff = !this.thff;
      },
      next(e) {
        this.sub1 = e;
      },
      submitYes(e) {
        let _this = this;
        if (e == 1) {
          _this.ruleForm.subStatus = 1;
        } else {
          _this.ruleForm.subStatus = 2;
        }
        this.ruleForm.price = this.yhyusuan;
        this.$http({
            method: "post",
            url: "v1/project/apply-two",
            data: this.ruleForm
          })
          .then(res => {
            if (res.data.code === 200) {
              if (res.data.data.code === 200) {

                this.$message({
                  type: "success",
                  message: "保存成功!"
                });
                _this.proimages = "";
                _this.$router.go(0)
              } else {
                this.$message({
                  type: "info",
                  message: res.data.data.message
                });

              }
            } else {
              this.$message({
                type: "info",
                message: res.data.data.message
              });

            }
          })
          .catch(err => {
            // console.log(error);(err);
          });
      },
      // 获取表单数据
      getDataDetails(id) {
        this.$http({
            method: "post",
            url: "v1/fei-project/details",
            data: {
              id: this.id
            }
          })
          .then(res => {
            let m = 0;
            if (res.data.data.code == 200) {
              this.box_loading = false;
              this.fileurl = res.data.data.data.ProjectDetails.probook;
              this.fileurl1 = res.data.data.data.ProjectDetails.fangan;
              this.fileurl2 = res.data.data.data.ProjectDetails.pifu;
              this.fileurl3 = res.data.data.data.ProjectDetails.pact;
              this.fileurl4 = res.data.data.data.ProjectDetails.promise;
              this.yusuan = res.data.data.data.ProjectDetails.price
              this.zData = res.data.data.data.ProjectDetails;
              this.zDate = res.data.data.data.ProjectReview;
              this.zData.name1 = this.zData.name;
              this.status = res.data.data.data.ProjectDetails.status;
              this.dataFile = JSON.parse(this.zData.proimages);
              let shili20 = this.zData.declare;
              if (res.data.data.data.text) {
                this.$alert(res.data.data.data.text, "提示", {
                  confirmButtonText: "确定",
                  callback: action => {}
                });
              }
              for (let i in res.data.data.data.ProjectReview) {
                if (res.data.data.data.ProjectReview[i].sta == 1) {
                  m = i;
                }
              }
              for (let n in this.zDate) {
                if (n - m <= 0) {
                  this.zDate[n].type = 1;
                } else {
                  this.zDate[n].type = 0;
                }
              }
              if (shili20) {
                this.shili20 = JSON.parse(shili20)[0].name;
                this.hz = this.shili20.lastIndexOf(".") + 1;
                if (this.hz > 12) {
                  this.shili20 = this.shili20.substr(0, 12) + "... .pdf"
                }
                this.shili20url = JSON.parse(shili20)[0].url;
                this.show20 = false;
                this.down20 = true;
              }
              let shili21 = this.zData.implementation;

              if (shili21) {
                this.shili21 = JSON.parse(shili21)[0].name;
                this.shili21url = JSON.parse(shili21)[0].url;
                this.show21 = false
                this.down21 = true;
                this.hz = this.shili21.lastIndexOf(".") + 1;
                if (this.hz > 12) {
                  this.shili21 = this.shili21.substr(0, 12) + "... .pdf"
                }
              }
              // 项目执行信息数据 -- 更改
              this.executio = res.data.data.data.ProjectDetails;
              //项目申报书
              let shili = res.data.data.data.ProjectDetails.probook;
              this.shili = shili.substring(shili.lastIndexOf("/") + 1);
              this.hz = this.shili.lastIndexOf(".") + 1;
              if (this.hz > 13) {
                this.shili = this.shili.substr(0, 12) + "... ." + shili.substring(shili.lastIndexOf(".") + 1)
              }
              //实施方案
              let shili1 = res.data.data.data.ProjectDetails.fangan;
              this.shili1 = shili1.substring(shili1.lastIndexOf("/") + 1);
              this.hz = this.shili1.lastIndexOf(".") + 1;
              if (this.hz > 13) {
                this.shili1 = this.shili1.substr(0, 12) + "... ." + shili1.substring(shili1.lastIndexOf(".") + 1)
              }
              // 立项批复文件
              let shili2 = res.data.data.data.ProjectDetails.pifu;
              if (shili2) {
                this.shili2 = shili2.substring(shili2.lastIndexOf("/") + 1);
                this.hz = this.shili2.lastIndexOf(".") + 1;
                if (this.hz > 13) {
                  this.shili2 = this.shili2.substr(0, 12) + "... ." + shili2.substring(shili2.lastIndexOf(".") + 1)
                }
                this.show1 = false
              }
              //项目合同
              let shili3 = res.data.data.data.ProjectDetails.pact;
              if (shili3) {
                this.shili3 = shili3.substring(shili3.lastIndexOf("/") + 1);
                this.hz = this.shili3.lastIndexOf(".") + 1;
                if (this.hz > 13) {
                  this.shili3 = this.shili3.substr(0, 12) + "... ." + shili3.substring(shili3.lastIndexOf(".") + 1)
                }
                this.show2 = false
              }
              //服务承诺书
              let shili4 = res.data.data.data.ProjectDetails.promise;
              if (shili4) {
                this.shili4 = shili4.substring(shili4.lastIndexOf("/") + 1);
                this.hz = this.shili4.lastIndexOf(".") + 1;
                if (this.hz > 13) {
                  this.shili4 = this.shili4.substr(0, 12) + "... ." + shili4.substring(shili4.lastIndexOf(".") + 1)
                }
                this.show3 = false
              }
              // 5个上传的显示
              // 图片显示
              if (this.fileurl) {
                var index = this.fileurl.lastIndexOf(".");
                var filetype = this.fileurl.substr(index + 1);
                if (
                  filetype == "png" ||
                  filetype == "jpg" ||
                  filetype == "jpeg"
                ) {
                  this.imageUrl = this.fileurl;
                } else {
                  this.imageUrl = "/index/timg.jpg";
                }
                if (filetype == "docx" || filetype == "doc") {
                  this.imageUrl = require("../../../static/img/word.png");
                } else if (filetype == "xls" || filetype == "xlsx") {
                  this.imageUrl = require("../../../static/img/excel.png");
                } else if (filetype == "pptx" || filetype == "ppt") {
                  this.imageUrl = require("../../../static/img/ppt.png");
                } else if (filetype == "pdf") {
                  this.imageUrl = require("../../../static/img/pdf.jpg");
                } else if (filetype == "zip" || filetype == "rar") {
                  this.imageUrl = require("../../../static/img/zip.png");
                } else if (filetype == "txt") {
                  this.imageUrl = require("../../../static/img/txt.jpg");
                }
              }
              if (this.fileurl1) {
                this.imageUrl1 = "/index/timg.jpg";
                var index = this.fileurl1.lastIndexOf(".");
                var filetype = this.fileurl1.substr(index + 1);
                if (filetype == "png" || filetype == "jpg" || filetype == "jpeg") {
                  this.imageUrl1 = this.fileurl1;
                }
                if (filetype == "docx" || filetype == "doc") {
                  this.imageUrl1 = require("../../../static/img/word.png");
                } else if (filetype == "xls" || filetype == "xlsx") {
                  this.imageUrl1 = require("../../../static/img/excel.png");
                } else if (filetype == "pptx" || filetype == "ppt") {
                  this.imageUrl1 = require("../../../static/img/ppt.png");
                } else if (filetype == "pdf") {
                  this.imageUrl1 = require("../../../static/img/pdf.jpg");
                } else if (filetype == "zip" || filetype == "rar") {
                  this.imageUrl1 = require("../../../static/img/zip.png");
                } else if (filetype == "txt") {
                  this.imageUrl1 = require("../../../static/img/txt.jpg");
                }
              }
              if (this.fileurl2) {
                this.imageUrl2 = "/index/timg.jpg";
                var index = this.fileurl2.lastIndexOf(".");
                var filetype = this.fileurl2.substr(index + 1);
                if (
                  filetype == "png" ||
                  filetype == "jpg" ||
                  filetype == "jpeg"
                ) {
                  this.imageUrl2 = this.fileurl2;
                }
                if (filetype == "docx" || filetype == "doc") {
                  this.imageUrl2 = require("../../../static/img/word.png");
                } else if (filetype == "xls" || filetype == "xlsx") {
                  this.imageUrl2 = require("../../../static/img/excel.png");
                } else if (filetype == "pptx" || filetype == "ppt") {
                  this.imageUrl2 = require("../../../static/img/ppt.png");
                } else if (filetype == "pdf") {
                  this.imageUrl2 = require("../../../static/img/pdf.jpg");
                } else if (filetype == "zip" || filetype == "rar") {
                  this.imageUrl2 = require("../../../static/img/zip.png");
                } else if (filetype == "txt") {
                  this.imageUrl2 = require("../../../static/img/txt.jpg");
                }
              }
              if (this.fileurl3) {
                this.imageUrl3 = "/index/timg.jpg";
                var index = this.fileurl3.lastIndexOf(".");
                var filetype = this.fileurl3.substr(index + 1);
                if (
                  filetype == "png" ||
                  filetype == "jpg" ||
                  filetype == "jpeg"
                ) {
                  this.imageUrl3 = this.fileurl3;
                }
                if (filetype == "docx" || filetype == "doc") {
                  this.imageUrl3 = require("../../../static/img/word.png");
                } else if (filetype == "xls" || filetype == "xlsx") {
                  this.imageUrl3 = require("../../../static/img/excel.png");
                } else if (filetype == "pptx" || filetype == "ppt") {
                  this.imageUrl3 = require("../../../static/img/ppt.png");
                } else if (filetype == "pdf") {
                  this.imageUrl3 = require("../../../static/img/pdf.jpg");
                } else if (filetype == "zip" || filetype == "rar") {
                  this.imageUrl3 = require("../../../static/img/zip.png");
                } else if (filetype == "txt") {
                  this.imageUrl3 = require("../../../static/img/txt.jpg");
                }
              }
              if (this.fileurl4) {
                this.imageUrl4 = "/index/timg.jpg";
                var index = this.fileurl4.lastIndexOf(".");
                var filetype = this.fileurl4.substr(index + 1);
                if (
                  filetype == "png" ||
                  filetype == "jpg" ||
                  filetype == "jpeg"
                ) {
                  this.imageUrl4 = this.fileurl4;
                }

                if (filetype == "docx" || filetype == "doc") {
                  this.imageUrl4 = require("../../../static/img/word.png");
                } else if (filetype == "xls" || filetype == "xlsx") {
                  this.imageUrl4 = require("../../../static/img/excel.png");
                } else if (filetype == "pptx" || filetype == "ppt") {
                  this.imageUrl4 = require("../../../static/img/ppt.png");
                } else if (filetype == "pdf") {
                  this.imageUrl4 = require("../../../static/img/pdf.jpg");
                } else if (filetype == "zip" || filetype == "rar") {
                  this.imageUrl4 = require("../../../static/img/zip.png");
                } else if (filetype == "txt") {
                  this.imageUrl4 = require("../../../static/img/txt.jpg");
                }
              }
              this.bgData = res.data.data.data.ProjectDetails
              if (this.bgData) {
                this.filename = this.bgData.probook ? this.bgData.probook.substring(
                  this.bgData.probook.lastIndexOf("/") + 1
                ) : '';
                this.filename1 = this.bgData.fangan ? this.bgData.fangan.substring(
                  this.bgData.fangan.lastIndexOf("/") + 1
                ) : '';
                this.filename2 = this.bgData.pifu ? this.bgData.pifu.substring(
                  this.bgData.pifu.lastIndexOf("/") + 1
                ) : '';
                this.filename3 = this.bgData.pact ? this.bgData.pact.substring(
                  this.bgData.pact.lastIndexOf("/") + 1
                ) : '';
                this.filename4 = this.bgData.promise ? this.bgData.promise.substring(
                  this.bgData.promise.lastIndexOf("/") + 1
                ) : '';

              }
              //ljj误删
              let shili9 = res.data.data.data.ProjectDetails.center.rectifi;
              if (shili9) {
                this.center.rectifi = shili9;
                this.shili9 = shili9.substring(shili9.lastIndexOf("/") + 1);
                this.hz = this.shili9.lastIndexOf(".") + 1;
                if (this.hz > 13) {
                  this.shili9 = this.shili9.substr(0, 12) + "... ." + shili9.substring(shili9.lastIndexOf(".") + 1)
                }
                this.show8 = false

              }
              //
              this.box_loading = false;
              // let shili6 = res.data.data.data.ProjectDetails.review_my;
              // if (shili6) {
              //   this.review_my_url = shili6;
              //   this.review_my = shili6 ?
              //     shili6.substring(shili6.lastIndexOf("/") + 1) :
              //     "";
              // }

              // let shili7 = res.data.data.data.ProjectDetails.review_zq;
              // if (shili7) {
              //   this.review_zq_url = shili7;
              //   this.review_zq = shili7 ?
              //     shili7.substring(shili7.lastIndexOf("/") + 1) :
              //     "";
              // }
              // let shili8 = res.data.data.data.ProjectDetails.review_my_zq;
              // if (shili8) {
              //   this.review_my_zq_url = shili8;
              //   this.review_my_zq = shili8 ?
              //     shili8.substring(shili8.lastIndexOf("/") + 1) :
              //     "";
              // }
              // let shili5 = res.data.data.data.ProjectDetails.review_jx;
              // if (shili5) {
              //   this.review_jx_url = shili5;
              //   this.review_jx = shili5 ?
              //     shili5.substring(shili5.lastIndexOf("/") + 1) :
              //     "";
              // }

            } else {
              this.box_loading = true;
            }
          })
          .catch(err => {});
      },
      assignment(data) {
        this.name = data.name;
        for (var prop in this.types) {
          if (data.tid === this.types[prop]) {
            this.tid = prop;
          }
        }

        for (let prop in this.area) {
          if (data.rid === this.area[prop]) {
            this.rid = prop;
          }
        }
        for (let prop in this.first_levels) {
          if (data.first_level === this.first_levels[prop]) {
            this.first_level = prop;
          }
        }
        this.secondary = data.secondary;
        this.fieldeara = data.fieldeara;
        this.attribute = data.attribute;
        this.aterm = data.aterm;
        this.fterm = data.fterm;
        this.postaladdress = data.postaladdress;
        this.postalcode = data.postalcode;
        this.pmail = data.pmail;
        this.fax_tel = data.fax_tel;
        this.plegal = data.plegal;
        this.plcode = data.plcode;
        this.pname = data.pname;
        this.poster = data.poster;
        this.poffice_tel = data.poffice_tel;
        this.aphone = data.aphone;
        this.cname = data.cname;
        this.cpost = data.cpost;
        this.coffice_tel = data.coffice_tel;
        this.cphone = data.cphone;
        this.prespo = data.prespo;
        this.respoadd = data.respoadd;
        this.respopcode = data.respopcode;
        this.respomail = data.respomail;
        this.respophone = data.respophone;
        this.respopname = data.respopname;
        this.respopost = data.respopost;
        this.respoophone = data.respoophone;
        this.respoptel = data.respoptel;
        this.respocname = data.respocname;
        this.respocpost = data.respocpost;
        this.respocophone = data.respocophone;
        this.respoctel = data.respoctel;
        this.aboutUsVal = data.decldes;
        this.aboutUsText = data.decldes;
        this.projectBriefVal = data.prodes;
        this.projectBriefText = data.prodes;
        this.projectAssessmentVal = data.prodemo;
        this.projectAssessmentText = data.prodemo;
        this.existingBasisVal = data.prodemojc;
        this.existingBasisText = data.prodemojc;
        this.methodsWayVal = data.prodemotj;
        this.methodsWayText = data.prodemotj;
        this.schedulingVal = data.prodemojd;
        this.schedulingText = data.prodemojd;
        this.desiredEffectVal = data.prodemoxg;
        this.desiredEffectText = data.prodemoxg;
        this.divisionLaborVal = data.prodemofg;
        this.divisionLaborText = data.prodemofg;
        this.coverVal = data.prodemotwo;
        this.coverText = data.prodemotwo;
        this.initialTextVal = data.funds;
        this.initialText = data.funds;
        this.pid = data.id;
        let imgs = JSON.parse(data.proimages);
        this.fileLists = imgs;
        this.picture = this.fileLists;
      },
      beforeAvatarUploadzq(file, fileList) {
        let fileName = file.name;
        let uid = file.uid
        let pos = fileName.lastIndexOf(".");
        let lastName = fileName.substring(pos, fileName.length);
        if (
          lastName.toLowerCase() !== ".doc" &&
          lastName.toLowerCase() !== ".docx" &&
          lastName.toLowerCase() !== ".pdf"
        ) {
          this.$message.error("文件必须为pdf、doc、docx 类型");

          for (var i = 0; i < fileList.length; i++) {
            if (fileList[i].uid == uid) {
              fileList.splice(i, 1)
            }
          }
          return;
        }
      },
      beforeAvatarUpload(file, fileList) {
        let fileName = file.name;
        let uid = file.uid
        let pos = fileName.lastIndexOf(".");
        let lastName = fileName.substring(pos, fileName.length);
        if (

          lastName.toLowerCase() !== ".pdf"
        ) {
          this.$message.error("文件必须为pdf 类型");
          for (var i = 0; i < fileList.length; i++) {
            if (fileList[i].uid == uid) {
              fileList.splice(i, 1)
            }
          }
          return;
        }

      },
      handleAvatarSuccess(res, file) {
        if (this.bgData.status == 1 || this.bgData.status == 4) {
          // this.$message.warning("已提交的的附件不能修改");
        } else {
          let houzui = file.split(".");
          houzui = houzui[houzui.length - 1];
          this.fileurl = res.url;
          this.filename = res.name; +
          "." + res.extension;
          this.ruleForm.probook = res.url;
          if (houzui == "doc" || houzui == "docx") {
            this.imageUrl = require("../../../static/img/word.png");
          } else if (houzui == "pptx" || houzui == "ppt") {
            this.imageUrl = require("../../../static/img/ppt.png");
          } else if (houzui == "pdf") {
            this.imageUrl = require("../../../static/img/pdf.jpg");
          } else if (houzui == "xls" || houzui == "xlsx") {
            this.imageUrl = require("../../../static/img/excel.png");
          } else if (houzui == "jpg" || houzui == "jpeg" || houzui == "png") {
            this.imageUrl = res.url;
          } else if (houzui == "zip" || houzui == "rar") {
            this.imageUrl = require("../../../static/img/zip.png");
          } else if (filetype == "txt") {
            this.imageUrl = require("../../../static/img/txt.jpg");
          }
          this.fileid = res.id;
        }
      },
      successUpload(response, file, fileList) {
        if (this.picture.length > 0) {
          this.picture.splice(1, 1);
          this.$message.error("只能上传一张文件");

          return;
        } else {
          this.picture.push({
            name: file.name,
            url: file.response.data.url
          });
        }
      },
      successUploadTwo(response) {
        this.fileid = response.data.id;
        this.filename = response.data.name;
        this.fileurl = response.data.url;
        this.fileLists1.push(response.data);
        this.dianziurl = response.data.url;
      },
      successUploadThree(response) {
        this.fileid = response.data.id;
        this.filename = response.data.name;
        this.fileurl = response.data.url;
        this.fileLists2.push(response.data);
        this.xinweiurl = response.data.url;

      },
      handleRemove1(file, fileList) {
        this.dianziurl != "" && (this.dianziurl = "");
        this.xinweiurl != "" && (this.xinweiurl = "");
        this.fileLists1.forEach(element => {
          if (file.name === element.name) {
            this.fileLists1.splice(this.fileLists1.lastIndexOf(element), 1);
          }
        });
        return;
      },
      handleRemove2(file, fileList) {
        this.dianziurl != "" && (this.dianziurl = "");
        this.xinweiurl != "" && (this.xinweiurl = "");
        this.fileLists2.forEach(element => {
          if (file.name === element.name) {
            this.fileLists2.splice(this.fileLists2.lastIndexOf(element), 1);
          }
        });
        return;
      },
      handleRemove(file, fileList) {
        if (!this.ifupdate) {
          this.picture.forEach(element => {
            if (file.name === element.name) {
              this.picture.splice(element, 1);
            }
          });
        }
      },
      handlePreview(file) {
        this.previewinfo = file;
        if (!!window.ActiveXObject || "ActiveXObject" in window) {
          alert("推荐谷歌进行文件预览");
        } else {
          window.open(file.url);
        }
      },
      handleExceed(files, fileList) {
        this.$message.warning(
          `当前限制选择 10 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
        );
      },
      handleExceed1(files, fileList) {
        this.$message.warning(
          `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
        );
      },
      beforeRemove(file, fileList) {
        if (this.ifupdate) {
          return false;
        } else {
          return this.$confirm(`确定移除 ${file.name} ?`);
          this.$message.success("删除成功");
          return;
        }
      },
      subBtn() {
        this.$confirm("此操作将保存当前填写的内容, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          if (this.fileLists1.length) {
            if (this.month) {
              this.$http({
                  method: "post",
                  url: "v1/fei-project/mon",
                  data: {
                    project_id: this.id,
                    month: Math.round(this.month / 1000),
                    elereport: JSON.stringify(this.fileLists1),
                    pid: this.fileLists1[0].id,
                    name: this.fileLists1[0].name,
                    mouth_id: this.editMouth_id
                  }
                })
                .then(res => {
                  if (res.data.data.code == 200) {
                    this.dialogTableVisible = false;
                    this.month = "";
                    this.getPostData();
                    this.$message({
                      type: "success",
                      message: "操作成功"
                    });
                    this.fileLists1 = [];
                    this.dianziurl = "";
                    this.editMouth_id = "";
                  } else {
                    this.$message({
                      type: "error",
                      message: res.data.data.msg
                    });
                    this.editMouth_id = "";
                    this.month = "";
                    this.dianziurl = "";
                    this.fileLists1 = [];
                    this.dialogTableVisible = false;
                  }
                })
                .catch(err => {
                  // console.log(error);(err);
                });
            } else {
              this.$message({
                type: "error",
                message: "请选择日期"
              });
            }
          } else {
            this.$message({
              type: "error",
              message: "请先上传电子版文件"
            });
          }
        });
      },
      toclose() {
        this.editMouth_id = "";
        this.month = "";
        this.fileLists1 = [];
        this.fileLists2 = [];
      },
      //提交月统计表
      subsBun() {
        if (this.fileLists2[0]) {
          if (this.month) {
            this.$http({
                method: "post",
                url: "v1/fei-project/news",
                data: {
                  project_id: this.id,
                  month: Math.round(this.month / 1000),
                  elereport: JSON.stringify(this.fileLists2),
                  pid: this.fileLists2[0].id,
                  name: this.fileLists2[0].name
                }
              })
              .then(res => {
                if (res.data.data.code === 200) {
                  this.dialogFormVisible = false;
                  this.getPostData();
                  this.fileLists2 = [];
                  this.$message({
                    type: "success",
                    message: "操作成功"
                  });
                  this.month = "";
                  this.xinweiurl = "";
                } else {
                  this.$message({
                    type: "error",
                    message: res.data.data.msg
                  });
                  this.month = "";
                  this.xinweiurl = "";
                  this.fileLists2 = [];
                  this.dialogFormVisible = false;
                }
              })
              .catch(err => {
                // console.log(error);(err);
              });
          } else {
            this.$message({
              type: "error",
              message: "请选择日期"
            });
          }
        } else {
          this.$message({
            type: "error",
            message: "请先上传电子版新闻稿"
          });
        }
      },
      hreftwo() {
        this.$jP("appcationnew", {
          id: this.id
        });
      },
      excute(id) {
        this.$http({
            method: "get",
            url: "v1/pro/center?id=" + id + "&category=" + 'center',
            query: {
              id: id,
              category: 'center'
            }
          })
          .then(res => {
            this.code = res.data.data.code
          })
          .catch(err => {
            // console.log(error);(err);
          });
      },
      over(id) {
        this.$http({
            method: "get",
            url: "v1/project/details?id=" + id + "&category=" + 'details',
            query: {
              id: id,
              category: 'details'
            }
          })
          .then(res => {
            this.code = res.data.data.code
          })
          .catch(err => {
            // console.log(error);(err);
          });
      },
      //中期评审材料查看
      excutes(id) {
        this.$http({
          method: "get",
          url: "v1/fei-project/chakan?id=" + id + "&category=" + 'center',
          query: {
            id: id,
            category: 'center'
          }
        }).then(res => {
          if (res.data.data.code == 200) {
            this.$router.push('/excute_solicitation?id=' + this.id)
          } else {
            this.$alert("未提交暂时无法查看", "提示", {
              confirmButtonText: "确定",
              callback: action => {}
            });
            return false;
          }
        }).catch(err => {
          // console.log(error);(err);
        });
      },
      //结项评审材料查看
      overs(id) {
        this.$http({
          method: "get",
          url: "v1/fei-project/chakan",
          params: {
            id: this.id,
            category: "over"
          }
        }).then(res => {
          if (res.data.data.code == 200) {
            this.$router.push('/over_solicitation?id=' + this.id)
          } else {
            this.$alert("未提交暂时无法查看", "提示", {
              confirmButtonText: "确定",
              callback: action => {}
            });
            return false;
          }
        }).catch(err => {
          // console.log(error);(err);
        });
      },
      //中期评审材料填并提交
      submit_mid() {
        let t = this;
        if (this.status >= 4) {
          var nowtime = Math.round(new Date().getTime() / 1000);
          this.$jP("submit_mid_solicitation", {
            id: this.id
          });
        } else {
          this.$alert('请等待项目申报审核通过 ', "提示", {
            'confirmButtonText': "确定",
            callback: action => {}
          });
          return false;
        }
      },
      // 结项评审材料填写并提交
      post_pro() {
        if (this.status >= 11) {
          var nowtime = Math.round(new Date().getTime() / 1000);
          this.$jP("post_pro_solicitation", {
            id: this.id
          });
        } else {
          this.$alert('请等待中期评审完成', "提示", {
            'confirmButtonText': "确定",
            callback: action => {}
          });
          return false;
        }
      },
      download() {
        this.getPdf("pdfDom", "项目申请书");
      },
      preview() {
        this.popupStatus = !this.popupStatus;
      },
      btn(index) {
        this.sub = index;
      },
      // 更改
      getData() {
        let _this = this;
        this.$http({
            method: "get",
            url: "v1/project/get-info",
            data: {}
          })
          .then(res => {
            if (res.data.code === 200) {
              _this.types = res.data.data.type;
              _this.area = res.data.data.area;
              _this.first_levels = res.data.data.first_level;
              if (this.$route.query.id) {

                let id = this.$route.query.id;
                this.getDataDetails(id);
              }
            } else {
              _this.$message.error("请求数据有问题！");
            }
          })
          .catch(err => {
            // console.log(error);(err);
          });
      },
      /** 项目执行信息获取 更改*/
      getPostData() {
        let _this = this;
        this.$http({
            method: "get",
            url: "v1/fei-project/execute",
            params: {
              project_id: _this.id
            }
          })
          .then(res => {

            if (res.data.code === 200) {

              if (res.data.data.data.length != 0) {
                _this.executio = res.data.data.data[0];
                // _this.jiance = res.data.data.data[0].det;
                _this.mont = res.data.data.data[0].mon;
                _this.newss = res.data.data.data[0].news;
                // _this.center = res.data.data.data[0].center;
                // let shili = res.data.data.data[0].probook;
                // _this.shili = shili.substring(shili.lastIndexOf("/") + 1);
                // _this.hz = _this.shili.lastIndexOf(".") + 1;
                // if (_this.hz > 13) {
                //   _this.shili = _this.shili.substr(0, 12) + "... ." + shili.substring(shili.lastIndexOf(".") + 1)
                // }

                // let shili1 = res.data.data.data[0].fangan;
                // _this.shili1 = shili1.substring(shili1.lastIndexOf("/") + 1);
                // _this.hz = _this.shili1.lastIndexOf(".") + 1;
                // if (_this.hz > 13) {
                //   _this.shili1 = _this.shili1.substr(0, 12) + "... ." + shili1.substring(shili1.lastIndexOf(".") + 1)
                // }

                // let shili2 = res.data.data.data[0].pifu;
                // if (shili2) {
                //   _this.shili2 = shili2.substring(shili2.lastIndexOf("/") + 1);
                //   _this.hz = _this.shili2.lastIndexOf(".") + 1;
                //   if (_this.hz > 13) {
                //     _this.shili2 = _this.shili2.substr(0, 12) + "... ." + shili2.substring(shili2.lastIndexOf(".") + 1)
                //   }
                //   _this.show1 = false
                // }

                // let shili3 = res.data.data.data[0].pact;
                // if (shili3) {
                //   _this.shili3 = shili3.substring(shili3.lastIndexOf("/") + 1);
                //   _this.hz = _this.shili3.lastIndexOf(".") + 1;
                //   if (_this.hz > 13) {
                //     _this.shili3 = _this.shili3.substr(0, 12) + "... ." + shili3.substring(shili3.lastIndexOf(".") + 1)
                //   }
                //   _this.show2 = false
                // }

                // let shili9 = res.data.data.data[0].center.rectifi;
                // if (shili9) {
                //   _this.shili9 = shili9.substring(shili9.lastIndexOf("/") + 1);
                //   _this.hz = _this.shili9.lastIndexOf(".") + 1;
                //   if (_this.hz > 13) {
                //     _this.shili9 = _this.shili9.substr(0, 12) + "... ." + shili9.substring(shili9.lastIndexOf(".") + 1)
                //   }
                //   _this.show8 = false
                // }

                // let shili4 = res.data.data.data[0].promise;
                // if (shili4) {
                //   _this.shili4 = shili4.substring(shili4.lastIndexOf("/") + 1);
                //   _this.hz = _this.shili4.lastIndexOf(".") + 1;
                //   if (_this.hz > 13) {
                //     _this.shili4 = _this.shili4.substr(0, 12) + "... ." + shili4.substring(shili4.lastIndexOf(".") + 1)
                //   }
                //   _this.show3 = false
                // }

                // let shili6 = res.data.data.data[0].review_my;
                // if (shili6) {
                //   _this.review_my_url = shili6;
                //   _this.review_my = shili6 ?
                //     shili6.substring(shili6.lastIndexOf("/") + 1) :
                //     "";
                // }

                // let shili7 = res.data.data.data[0].review_zq;
                // if (shili7) {
                //   _this.review_zq_url = shili7;
                //   _this.review_zq = shili7 ?
                //     shili7.substring(shili7.lastIndexOf("/") + 1) :
                //     "";
                // }

                // let shili8 = res.data.data.data[0].review_my_zq;
                // if (shili8) {
                //   _this.review_my_zq_url = shili8;
                //   _this.review_my_zq = shili8 ?
                //     shili8.substring(shili8.lastIndexOf("/") + 1) :
                //     "";
                // }

                // let shili5 = res.data.data.data[0].review_jx;
                // if (shili5) {
                //   _this.review_jx_url = shili5;
                //   _this.review_jx = shili5 ?
                //     shili5.substring(shili5.lastIndexOf("/") + 1) :
                //     "";
                // }
              } else {
                this.proinfo = false;
              }
            } else {}
          })
          .catch(err => {
            // console.log(error);(err);
          });
      },
      // 项目执行信息预览
      popUp(link) {
        this.pop = !this.pop;
        this.linkData = link;
      },
      aboutUs(data) {
        this.ruleForm.decldes = data;
      },
      projectBrief(data) {
        this.ruleForm.prodes = data;
      },
      existingBasis(data) {
        this.ruleForm.prodemojc = data;
      },
      methodsWay(data) {
        this.ruleForm.prodemotj = data;
      },
      scheduling(data) {
        this.ruleForm.prodemojd = data;
      },
      desiredEffect(data) {
        this.ruleForm.prodemoxg = data;
      },
      projectAssessment(data) {
        this.ruleForm.prodemo = data;
      },
      divisionLabor(data) {
        this.ruleForm.prodemofg = data;
      },
      cover(data) {
        this.ruleForm.prodemotwo = data;
      },
      quillVal(data) {
        this.ruleForm.funds = data;
      },
      handleAvatarSuccess1(res, file) {
        if (this.bgData.status == 1 || this.bgData.status == 4) {} else {
          let houzui = file.split(".");
          houzui = houzui[houzui.length - 1];
          this.fileurl1 = res.url;
          this.filename1 = res.name; +
          "." + res.extension;
          this.ruleForm.fangan = res.url;
          if (houzui == "doc" || houzui == "docx") {
            this.imageUrl1 = require("../../../static/img/word.png");
          } else if (houzui == "pptx" || houzui == "ppt") {
            this.imageUrl1 = require("../../../static/img/ppt.png");
          } else if (houzui == "pdf") {
            this.imageUrl1 = require("../../../static/img/pdf.jpg");
          } else if (houzui == "xls" || houzui == "xlsx") {
            this.imageUrl1 = require("../../../static/img/excel.png");
          } else if (houzui == "jpg" || houzui == "jpeg" || houzui == "png") {
            this.imageUrl1 = res.url;
          } else if (houzui == "zip" || houzui == "rar") {
            this.imageUrl1 = require("../../../static/img/zip.png");
          } else if (filetype == "txt") {
            this.imageUrl1 = require("../../../static/img/txt.jpg");
          }
        }
      },
      handleAvatarSuccess2(res, file) {
        if (this.bgData.status == 1 || this.bgData.status == 4) {
          // this.$message.warning("已提交的的附件不能修改");
        } else {
          let houzui = file.split(".");
          houzui = houzui[houzui.length - 1];

          this.fileurl2 = res.url;
          this.filename2 = res.name; +
          "." + res.extension;
          this.ruleForm.pifu = res.url;

          if (houzui == "doc" || houzui == "docx") {
            this.imageUrl2 = require("../../../static/img/word.png");
          } else if (houzui == "pptx" || houzui == "ppt") {
            this.imageUrl2 = require("../../../static/img/ppt.png");
          } else if (houzui == "pdf") {
            this.imageUrl2 = require("../../../static/img/pdf.jpg");
          } else if (houzui == "xls" || houzui == "xlsx") {
            this.imageUrl2 = require("../../../static/img/excel.png");
          } else if (houzui == "jpg" || houzui == "jpeg" || houzui == "png") {
            this.imageUrl2 = res.url;
          } else if (houzui == "zip" || houzui == "rar") {
            this.imageUrl2 = require("../../../static/img/zip.png");
          } else if (houzui == "txt") {
            this.imageUrl2 = require("../../../static/img/txt.jpg");
          }
        }
      },
      handleAvatarSuccess3(res, file) {
        if (this.bgData.status == 1 || this.bgData.status == 4) {
          // this.$message.warning("已提交的的附件不能修改");
        } else {

          let houzui = file.split(".");
          houzui = houzui[houzui.length - 1];

          this.fileurl3 = res.url;
          this.filename3 = res.name; +
          "." + res.extension;
          this.ruleForm.pact = res.url;

          if (houzui == "doc" || houzui == "docx") {
            this.imageUrl3 = require("../../../static/img/word.png");
          } else if (houzui == "pptx" || houzui == "ppt") {
            this.imageUrl3 = require("../../../static/img/ppt.png");
          } else if (houzui == "pdf") {
            this.imageUrl3 = require("../../../static/img/pdf.jpg");
          } else if (houzui == "xls" || houzui == "xlsx") {
            this.imageUrl3 = require("../../../static/img/excel.png");
          } else if (houzui == "jpg" || houzui == "jpeg" || houzui == "png") {
            this.imageUrl3 = res.url;
          } else if (houzui == "zip" || houzui == "rar") {
            this.imageUrl3 = require("../../../static/img/zip.png");
          } else if (filetype == "txt") {
            this.imageUrl3 = require("../../../static/img/txt.jpg");
          }

        }

      },
      handleAvatarSuccess4(res, file) {
        if (this.bgData.status == 1 || this.bgData.status == 4) {
          // this.$message.warning("已提交的的附件不能修改");
        } else {

          let houzui = file.split(".");
          houzui = houzui[houzui.length - 1];

          this.fileurl4 = res.url;
          this.filename4 = res.name; +
          "." + res.extension;
          this.ruleForm.promise = res.url;

          if (houzui == "doc" || houzui == "docx") {
            this.imageUrl4 = require("../../../static/img/word.png");
          } else if (houzui == "pptx" || houzui == "ppt") {
            this.imageUrl4 = require("../../../static/img/ppt.png");
          } else if (houzui == "pdf") {
            this.imageUrl4 = require("../../../static/img/pdf.jpg");
          } else if (houzui == "xls" || houzui == "xlsx") {
            this.imageUrl4 = require("../../../static/img/excel.png");
          } else if (houzui == "jpg" || houzui == "jpeg" || houzui == "png") {
            this.imageUrl4 = res.url;
          } else if (houzui == "zip" || houzui == "rar") {
            this.imageUrl4 = require("../../../static/img/zip.png");
          } else if (filetype == "txt") {
            this.imageUrl4 = require("../../../static/img/txt.jpg");
          }

        }


      },
      delfileLists1() {
        this.fileLists1 = [];
        this.dianziurl = "";
        this.$refs.dianzi.clearFiles();
      },
      delfileLists2() {
        this.fileLists2 = [];
        this.xinweiurl = "";
        this.$refs.xinwen.clearFiles();
      }
    },
    created() {
      this.ruleForm.funds = ""
      this.ruleForm.prodemotwo = ""
      this.ruleForm.prodemofg = ""
      this.ruleForm.prodemoxg = ""
      this.ruleForm.prodemojd = ""
      this.ruleForm.prodemotj = ""
      this.ruleForm.prodemojc = ""
      this.ruleForm.prodemo = ""
      this.ruleForm.prodes = ""
    },
    mounted() {
      this.id = this.$route.params.id;
      if (this.$route.params.mid_sub == 1) {
        this.sub = 2;
      }
      this.project_id = this.$route.query.id;
      //更改
      this.getPostData();
      this.getDataDetails(this.$route.query.id);
    }
  };

</script>
<style lang="scss" scoped>
  .wrapper /deep/ #box /deep/ form {
    margin-left: 50px;
    width: 1100px;
    background: #fff;
  }



  /deep/ .el-icon-close-tip {
    display: none !important;
  }

  .close {
    position: relative;
    left: 150px;
    top: -10px;
    cursor: pointer;
  }

  .yulantext {
    font-size: 10px;
    position: absolute;
    // top: 44px;
    bottom: 26px;
    left: 288px;
    z-index: 999;
    color: #409eff;
    cursor: pointer;
  }

  .el-upload__tip {
    width: 300px;
    text-indent: -153px;
  }

  .wrapper /deep/ .el-upload-list {
    // width: 82%;
    width: 575px;
    // margin-left: 175px;
  }

  .wrapper /deep/ .el-upload-list__item-name {
    width: 310px;
    position: relative;
  }

  .wrapper /deep/ .el-upload-list__item {
    width: 440px;
    position: relative;
    right: 190px;
  }

  .yuedu {
    margin-top: 10px;
    display: flex;
    position: relative;
    left: -15px;

    label {
      width: 150px;
      margin-top: 10px;
    }
  }

  .d1 {
    position: relative;
    left: 6px;
    margin: 6px 0;
  }

  .title1 {
    position: relative;
    right: 474px;
  }

  .yulan {
    margin-left: 15px !important;
  }

  .wrapper /deep/ th {
    height: 64px !important;
    line-height: 64px !important;
    font-size: 19px !important;
    color: #fff !important;
  }

  .wrapper /deep/ table td {
    height: 53px;
    line-height: 53px;
  }

  #wrapper {
    min-width: 1200px;
  }

  #one_e {
    width: 100%;
    margin-top: 27px;
    margin-bottom: 60px;
    padding-top: 27px;
  }

  #popup {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0%;
    left: 0%;
    z-index: 999;
    background-color: rgba($color: #000000, $alpha: 0.8);

    aside {
      background: #fff;
      width: 50%;
      height: 80vh;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  #preview {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0%;
    left: 0%;
    z-index: 999;

    .tc {
      width: 100%;
      height: 100%;
      background-color: rgba($color: #000, $alpha: 0.58);
      position: fixed;
      top: 0%;
      left: 0%;
      // display: none;
    }

    .tc-text {
      padding: 30px;
      box-sizing: border-box;
      height: auto;
      background-color: #fff;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);

      a {
        display: inline-block;
        margin-top: 10px;
        cursor: pointer;
      }
    }
  }

  .fliter {
    -webkit-filter: blur(10px);
    -o-filter: blur(10px);
    -moz-filter: blur(10px);
    filter: blur(10px);
  }

  .wrapper {
    min-width: 1280px;
    box-sizing: border-box;

    #box {
      width: 1200px;
      background-color: #ffffff;
      box-sizing: border-box;
      position: relative;

      .boxx {
        width: 100%;
        margin-left: 27px;
        box-sizing: border-box;

        .one-e {
          width: 955px;
          margin-top: 27px;
          margin-bottom: 60px;
          margin-left: 46px;

          p {
            // font-family: "MicrosoftYaHei";
            font-size: 18px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 39px;
            letter-spacing: 0px;
            color: #666666;
            margin-left: 32px;
          }

          span {
            font-family: "MicrosoftYaHei";
            font-size: 18px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 39px;
            letter-spacing: 0px;
            color: #7471ef;
          }
        }

        .one-o {
          width: 100%;
          display: flex;
          justify-content: center;
          // align-items: center;
          margin-top: 30px;
          margin-bottom: 60px;
          // margin-left: -71px;

          // .el-upload-list {
          //   // margin-left: 150px;
          // }
          ul {
            width: 321px;
            min-height: 674px;
            box-shadow: 0px 4px 18px 0px rgba(0, 0, 0, 0.15);
            border-radius: 5px;
            padding: 30px 0 0 20px;
            box-sizing: border-box;
            margin-right: 56px;

            li {
              font-family: "MicrosoftYaHei";
              font-size: 18px;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: 0px;
              line-height: 40px;
              // margin-bottom: 28px;
              color: #333333;
            }
          }
        }

        h3 {
          font-family: "MicrosoftYaHei";
          font-size: 20px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #333333;
        }

        h4 {
          margin-top: 38px;
          font-family: "MicrosoftYaHei";
          font-size: 20px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #333333;
          position: relative;
          right: -39px;
        }

        h5 {
          margin-top: 38px;
          font-family: "MicrosoftYaHei";
          font-size: 20px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #333333;
          margin-left: 50px;
        }
      }

      .bobb {
        margin-top: 110px;
        width: 100%;
        height: 974px;
        padding: 0 40px 0 11px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;

        .left {
          width: 419px;
          height: 974px;
          display: flex;
          justify-content: space-evenly;
          align-items: flex-start;
          margin-bottom: 163px;

          .time {
            width: 120px;
            height: 734px;
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            align-items: flex-end;
            margin-top: 72px;

            .span {
              display: inline-block;
              width: 119px;
              height: 18px;
              font-family: "MicrosoftYaHei";
              font-size: 22px;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: 0px;
              color: #333333;
            }
          }

          .jdt {
            width: 32px;
            height: 780px;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            position: relative;
            top: 0px;

            .sx0 {
              width: 3px;
              height: 48px;
              margin-left: 14px;
            }

            .sx1 {
              width: 3px;
              height: 61px;
              margin-left: 14px;
            }

            .wzx {
              width: 20px;
              height: 21px;
            }

            .zx {
              width: 20px;
              height: 21px;
            }
          }

          .bb {
            width: 180px;
            height: 870px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            padding-top: 50px;

            .o {
              padding-left: 5px;
              box-sizing: border-box;
              width: 170px;
              position: relative;
              border-bottom: 2px solid #b0c3cd;
              margin-bottom: 54px;

              img {
                width: 10px;
                height: 10px;
                position: absolute;
                right: 0%;
                bottom: -16%;
              }
            }

            div {
              padding-left: 5px;
              box-sizing: border-box;
              width: 100%;
              height: 36px;
              position: relative;
              border-bottom: 2px solid #b0c3cd;

              img {
                width: 10px;
                height: 10px;
                position: absolute;
                right: 0%;
                bottom: -16%;
              }

              section {
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                width: 132%;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 0px;
                font-family: "MicrosoftYaHei";
                position: absolute;
                left: -8%;
                bottom: -100%;
                white-space: nowrap;
              }
            }

            span {
              display: inline-block;
              width: 135px;
              height: 22px;
              text-align: center;
              line-height: 22px;
              font-family: "MicrosoftYaHei";
              font-size: 15px;
              font-weight: bold;
              font-stretch: normal;
              letter-spacing: 0px;
              color: #333333;
            }
          }
        }

        .newButton {
          position: absolute;
          top: 0;
          right: 300px;
          z-index: 999;
          top: -80px;

          .newBtn {
            height: 45px;
            width: 150px;
            background: #e60012;
            color: #fff;
            border: none;
            font-weight: bold;
            border-radius: 10px;
          }
        }

        .right {
          // padding: 35px 30px;
          box-sizing: border-box;
          width: 535px;
          height: 1000px;
          position: relative;
          z-index: 0;
          bottom: 40px;

          // box-shadow: 0px 4px 18px 0px rgba(0, 0, 0, 0.15);
          // border-radius: 10px;
          img {
            width: 100% !important;
            height: 100% !important;
          }

          ul {
            margin-top: 48px;

            li {
              font-family: "MicrosoftYaHei";
              font-size: 18px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 48px;
              letter-spacing: 0px;
              color: #666666;
            }

            .xd {
              width: 343px;
              height: 472px;
            }
          }

          p {
            text-align: center;
            width: 100%;
            font-family: "MicrosoftYaHei";
            font-size: 24px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 31px;
            letter-spacing: 0px;
            color: #333333;
          }
        }
      }

      .img {
        width: 119px;
        height: 95px;
        position: absolute;
        right: 0%;
        top: 1%;

        img {
          width: 119px;
          height: 95px;
        }
      }

      .top {
        width: 1160px;
        height: 67px;
        line-height: 67px;
        border-bottom: 1px solid #ccc;
        padding-left: 12px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .daochu {
          width: 96px;
          height: 32px;
          cursor: pointer;
          background-image: linear-gradient(69deg,
              #cc263f 0%,
              #f42b47 100%,
              #ed162d 100%,
              #e60012 100%),
            linear-gradient(#e60012, #e60012);
          background-blend-mode: normal, normal;
          border-radius: 66px;
          font-family: "MicrosoftYaHei";
          font-size: 16px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 32px;
          text-align: center;
          letter-spacing: 0px;
          color: #ffffff;
        }

        .span {
          span {
            margin-right: 40px;
            display: inline-block;
            width: 120px;
            height: 38px;
            text-align: center;
            font-family: "MicrosoftYaHei";
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #333333;
          }

          .style {
            color: #e60012;
            position: relative;

            &::after {
              content: "";
              width: 120px;
              height: 2px;
              background-color: #e60012;
              position: absolute;
              bottom: -31px;
              left: 0%;
            }
          }
        }
      }
    }

    // 项目执行信息css
    .Project_Execution_box {
      background-color: white;
      width: 1139px;
      margin: 0 auto;
      padding-left: 58px;

      .Project_Execution_name_text {
        font-size: 18px;
        color: #000;
        font-weight: 500;
      }

      .text-div {
        width: 390px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 100px;
      height: 96px;
      line-height: 80px;
      text-align: center;
      border: 1.5px dashed #666;
      margin-top: 2px;
    }

    .avatar {
      width: 100px !important;
      height: 96px !important;
      display: block;
    }

    .excuteBox {
      // border: 1px solid red;
      width: 100%;
      height: 800px;
    }

    .excute_list {
      float: left;
    }

    .excute_list li {
      font-size: 18px;
      line-height: 50px;
      color: #333;
    }

    // 123
    .excute_rt li {
      line-height: 49px;
      color: #666666;
      display: flex;
      align-items: center;
    }

    .excute_rt {
      margin-left: 129px;
      // float: left;
    }

    .excute_rt span {
      padding-right: 10px;
      font-size: 14px;
      color: #7471ef;
    }

    .excute_rt a {
      font-size: 14px;
      color: #7471ef;
    }

    .excute_tab {
      clear: both;
      width: 90%;
      margin: 0 auto;
      padding-top: 40px;
      // border: 1px solid green;
    }

    /deep/ .el-button--primary {
      border: none;
      cursor: pointer;
      margin-right: 20px;
      height: 30px;
      border-radius: 4px;
      background-image: linear-gradient(69deg,
          #cc263f 0%,
          #f42b47 100%,
          #ed162d 100%,
          #e60012 100%),
        linear-gradient(#e60012, #e60012);
      font-family: "MicrosoftYaHei";
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #ffffff;
    }

    .caption {
      width: 100%;
      height: 38px;
      border-bottom: 1px solid #dedede;
      margin-top: 76px;
      margin-bottom: 30px;
      padding-left: 30px;
      box-sizing: border-box;
      position: relative;

      span {
        display: inline-block;
        height: 38px;
        text-align: center;
        font-family: "MicrosoftYaHei";
        font-size: 20px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #333333;
        margin-right: 49px;
      }

      span.active {
        border-bottom: 2px solid #7471ef;
      }

      .speed_box {
        position: absolute;
        right: 10px;
        top: 0px;
      }

      .speed_box a {
        color: #7471ef;
        font-size: 16px;
      }
    }

    th {
      line-height: 40px;
      text-align: center;
      height: 40px;
      font-family: "MicrosoftYaHei";
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #666666;
      // background-color: rgba(247, 247, 247, 1);
      background: #a3a3a3;
      box-sizing: border-box;

      &:nth-of-type(1) {
        width: 200px;
      }

      &:nth-of-type(2) {
        width: 250px;
      }

      &:nth-of-type(3) {
        width: 200px;
      }

      &:nth-of-type(4) {
        width: 200px;
      }

      &:nth-of-type(5) {
        width: 180px;
      }
    }

    .statistics {
      height: 258px;
      overflow-y: auto;

      td {
        border: 1px solid #eee !important;
        vertical-align: middle;
      }
    }

    .on {
      background-color: #fff;
    }

    .off {
      background-color: #f7f7f7;
      // background: #a3a3a3;
    }

    // .off td {
    // }
    .monitor {
      th {
        width: 252px;
        border: 2px solid #d7d3d3;
      }

      td {
        width: 260px;
        border: 2px solid #d7d3d3 !important;
        vertical-align: middle;
      }
    }

    .news_release {
      height: 10000px;

      td {
        border: none !important;
        vertical-align: middle;
      }
    }

    .footer {
      width: 100% !important;
      margin-top: 80px;
      position: relative;
    }

    label {
      margin-left: 16px;
      font-family: "MicrosoftYaHei";
      font-size: 16px;
      font-weight: bold;
      font-stretch: normal;
      line-height: 25px;
      letter-spacing: 0px;
      color: #333333;
      text-align: right;
      display: inline-block;
    }

    input {
      box-sizing: border-box;
      width: 33.8%;
      height: 35px;
      background-color: #ffffff;
      border: solid 1px #c7c7c7;
      outline: none;
      // margin-left: 35px;
      margin-bottom: 15px;
      font-family: "MicrosoftYaHei";
      font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #323232;
      // margin-right: 35px;
    }
  }

  select {
    box-sizing: border-box;
    width: 33.8%;
    height: 35px;
    background-color: #ffffff;
    border: solid 1px #c7c7c7;
    outline: none;
    margin-left: 35px;
    margin-bottom: 15px;
    font-family: "MicrosoftYaHei";
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #323232;
    margin-right: 35px;
  }

  .mid_box {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;

    .z_box {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    .avatar-uploader {
      margin-right: 40px;
    }
  }

  .rich {
    z-index: 10;
    width: 100%;
    margin: 30px 0px;
    height: 320px;
  }

  .img-img {
    margin-top: 25px;
    width: 150px;
    height: auto;

    &::-webkit-scrollbar {
      width: 0px;
      height: 0px;
    }
  }

  .wrapper {
    min-width: 1300px;
    // padding: 30px;
    box-sizing: border-box;

    .queren {
      z-index: 999;
      width: 100%;
      height: 100%;
      position: fixed;
      left: 0%;
      top: 0%;
      background-color: rgba($color: #000, $alpha: 0.56);
      display: flex;
      align-items: center;
      justify-content: center;

      &>div {
        width: 500px;
        height: 400px;
        background: #fff;
        border-radius: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 0 100px 0 100px;
        box-sizing: border-box;

        &>span {
          text-align: center;
          width: 120%;
          color: #000;
        }

        &>p {
          font-size: 32px;
          font-weight: 600;
          width: 258px;
        }

        &>div {
          width: 100%;
          padding: 32px;
          box-sizing: border-box;
          margin: 20px auto 0;
          display: flex;
          justify-content: space-between;
          align-items: center;

          span {
            font-size: 30px;
            cursor: pointer;
          }
        }
      }
    }

    #box {
      // margin: 40px auto 0;
      // padding: 34px 32px 100px 28px;
      box-sizing: border-box;
      width: 1200px;
      background-color: #ffffff;
      margin: 0 auto;
      margin-top: 12px;

      form {
        width: 1100px;
        // margin: 0 auto;
        margin-left: 50px;
        // padding: 0 20px;
        background: white;

        .ll {
          margin-top: 80px;
          // margin-left: -94px;
          padding-bottom: 100px;
          width: 100%;
          display: flex;
          justify-content: flex-end;
          align-items: center;

          button[type="button"] {
            margin-right: 152px;
            width: 197px;
            height: 63px;
            background-color: #ff9800;
            border-radius: 5px;
            font-family: "MicrosoftYaHei";
            font-size: 26px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 63px;
            letter-spacing: 0px;
            color: #ffffff;
            text-align: center;
            outline: none;
            border: 0;
          }

          button[type="submit"] {
            width: 197px;
            height: 63px;
            background-color: #e60012;
            border-radius: 5px;
            font-family: "MicrosoftYaHei";
            font-size: 26px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 63px;
            text-align: center;
            letter-spacing: 0px;
            color: #ffffff;
            outline: none;
            border: 0;
          }
        }

        .xxx {
          margin-top: 60px;
          width: 100%;
          // height: 72px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: flex-start;

          .plpl {
            display: flex;
            align-items: center;

            label {
              margin-left: 16px;
              font-family: "MicrosoftYaHei";
              font-size: 16px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 25px;
              letter-spacing: 0px;
              color: #323232;
            }

            .iconfont {
              font-size: 22px;
              color: #999;
            }

            .ic {
              color: #e60012;
            }
          }

          .xxxx {
            margin: 10px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            // overflow: auto;
            width: 394px;
            position: relative;

            /deep/ .el-upload-list {
              margin-left: 178px;
            }

            span {
              display: inline-block;
              height: 32px;
              line-height: 32px;
              text-align: center;
              margin-left: 25px;
              font-family: "MicrosoftYaHei";
              font-size: 16px;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: 0px;
              color: #000;
            }

            /deep/ .upload-demo {
              margin-bottom: 10%;
              width: 200px;
            }

            /deep/ .el-button--primary {
              margin-top: 3px;
              border: none;
              cursor: pointer;
              width: 96px;
              height: 32px;
              border-radius: 4px;
              background-image: linear-gradient(69deg,
                  #cc263f 0%,
                  #f42b47 100%,
                  #ed162d 100%,
                  #e60012 100%),
                linear-gradient(#e60012, #e60012);
              font-family: "MicrosoftYaHei";
              font-size: 16px;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: 0px;
              color: #ffffff;
            }

            /deep/ .el-upload-list.el-upload-list--text {
              max-height: 100px;
              // width: 353px;

              // overflow-y: scroll;

              &::-webkit-scrollbar {
                width: 3px;
                // height: 5px;
              }

              &::-webkit-scrollbar-track-piece {
                background-color: rgba(0, 0, 0, 0.2);
                -webkit-border-radius: 6px;
                border-radius: 6px;
              }

              &::-webkit-scrollbar-thumb:vertical {
                height: 5px;
                background-color: rgba(125, 125, 125, 0.7);
                -webkit-border-radius: 6px;
                border-radius: 6px;
              }

              &::-webkit-scrollbar-thumb:horizontal {
                width: 5px;
                background-color: rgba(125, 125, 125, 0.7);
                -webkit-border-radius: 6px;
                border-radius: 6px;
              }
            }
          }

          .btnn {
            cursor: pointer;
            width: 96px;
            height: 32px;
            background-image: linear-gradient(69deg,
                #cc263f 0%,
                #f42b47 100%,
                #ed162d 100%,
                #e60012 100%),
              linear-gradient(#e60012, #e60012);
            background-blend-mode: normal, normal;
            border-radius: 4px;
            display: flex;
            justify-content: center;
            align-items: center;

            label {
              font-family: "MicrosoftYaHei";
              font-size: 16px;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: 0px;
              color: #ffffff;
            }
          }
        }

        .xx {
          margin-top: 60px;
          width: 100%;
          height: auto;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: flex-start;

          textarea {
            margin-top: 30px;
            width: 1139px;
            height: 138px;
            background-color: #ffffff;
            border: solid 1px #c7c7c7;
            resize: none !important;

            font-family: "MicrosoftYaHei";
            font-size: 18px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 39px;
            letter-spacing: 0px;
            color: #999999;
          }

          article {
            font-family: "MicrosoftYaHei";
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 39px;
            letter-spacing: 0px;
            color: #999;
          }

          p {
            margin-top: 38px;
            font-family: "MicrosoftYaHei";
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #333333;
          }

          h5 {
            width: 100%;
            font-family: "MicrosoftYaHei";
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #333333;
          }

          h3 {
            width: 100%;
            font-family: "MicrosoftYaHei";
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #333333;
            margin-top: 38px;
          }
        }

        .cc {
          width: 1140px;
          margin: 0 auto 0px;

          aside {
            width: 100%;
            height: 43px;
            right: -7px;

            div {
              display: flex;
              align-items: center;

              label {
                display: inline-block;
                // width: 101px;
                height: 43px;
                font-family: "MicrosoftYaHei";
                font-size: 16px;
                font-weight: normal;
                font-stretch: normal;
                line-height: 43px;
                text-align: right;
                letter-spacing: 0px;
                color: #323232;
                white-space: nowrap;
              }

              .i-i {
                width: 1009px;
                height: 43px;
                background-color: #ffffff;
                border: solid 1px #c7c7c7;
                outline: none;
                margin-left: 20px;
                font-family: "MicrosoftYaHei";
                font-size: 18px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 0px;
                color: #323232;
              }
            }
          }
        }

        .btn {
          margin: 60px auto 0;
          width: 230px;
          height: 63px;
          background-color: #e60012;
          border-radius: 5px;
          font-family: "MicrosoftYaHei";
          font-size: 26px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 63px;
          letter-spacing: 0px;
          text-align: center;
          color: #ffffff;
        }

        aside {
          width: 1138px;
          height: 43px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 30px;
          position: relative;

          right: 69px label {
            display: inline-block;
            width: 130px;
            height: 43px;
            font-family: "MicrosoftYaHei";
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 43px;
            text-align: right;
            letter-spacing: 0px;
            color: #323232;
            white-space: nowrap;
          }

          select {
            /* 清除默认的箭头样式 */
            appearance: none;
            -moz-appearance: none;
            -webkit-appearance: none;
            /* 右侧添加小箭头的背景图 */
            background: url("../../../static/img/xa.png") 360px center no-repeat;
            background-size: 14px 8px;
            width: 386px;
            height: 43px;
            background-color: #ffffff;
            border: solid 1px #c7c7c7;
            // padding-left: 83px;
            box-sizing: border-box;
            outline: none;
            margin-left: 20px;
            font-family: "MicrosoftYaHei";
            font-size: 18px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #323232;
          }

          input {
            box-sizing: border-box;
            width: 386px;
            height: 43px;
            background-color: #ffffff;
            border: solid 1px #c7c7c7;
            outline: none;
            margin-left: 20px;
            font-family: "MicrosoftYaHei";
            font-size: 18px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #323232;
          }

          .i {
            width: 151px;
            height: 43px;
            background-color: #ffffff;
            border: solid 1px #c7c7c7;
            outline: none;
            margin-left: 20px;
            font-family: "MicrosoftYaHei";
            font-size: 18px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #323232;
          }
        }

        section {
          width: 1138px;
          height: 43px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 65px;

          label {
            display: inline-block;
            width: 100px;
            height: 43px;
            font-family: "MicrosoftYaHei";
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 43px;
            text-align: right;
            letter-spacing: 0px;
            color: #323232;
            white-space: nowrap;
          }

          select {
            /* 清除默认的箭头样式 */
            appearance: none;
            -moz-appearance: none;
            -webkit-appearance: none;
            /* 右侧添加小箭头的背景图 */
            background: url("../../../static/img/xa.png") 360px center no-repeat;
            background-size: 14px 8px;
            width: 386px;
            height: 43px;
            background-color: #ffffff;
            border: solid 1px #c7c7c7;
            // padding-left: 83px;
            box-sizing: border-box;
            outline: none;
            margin-left: 20px;
            font-family: "MicrosoftYaHei";
            font-size: 18px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #323232;
          }

          input {
            box-sizing: border-box;
            width: 386px;
            height: 43px;
            background-color: #ffffff;
            border: solid 1px #c7c7c7;
            outline: none;
            margin-left: 20px;
            font-family: "MicrosoftYaHei";
            font-size: 18px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #323232;
          }

          .i {
            width: 151px;
            height: 43px;
            background-color: #ffffff;
            border: solid 1px #c7c7c7;
            outline: none;
            margin-left: 20px;
            font-family: "MicrosoftYaHei";
            font-size: 18px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #323232;
          }
        }

        h4 {
          width: 1138px;
          height: 38px;
          font-family: "MicrosoftYaHei";
          font-size: 20px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #333333;
          padding-left: 30px;
          box-sizing: border-box;
          border-bottom: 1px solid #ccc;
          margin-bottom: 54px;
        }
      }

      .box {
        width: 395px;
        height: 34px;
        margin: 44px auto 70px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        div {
          width: 192px;
          height: 34px;
          background-size: 100% 100%;
          font-family: "MicrosoftYaHei";
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 34px;
          text-align: center;
          letter-spacing: 0px;
          color: #333333;
        }

        .color {
          color: #fff;
        }
      }

      h3 {
        width: 215px;
        height: 23px;
        margin: 0 auto;
        font-family: "MicrosoftYaHei";
        font-size: 22px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #333333;
      }
    }

    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 100px;
      height: 96px;
      line-height: 100px;
      text-align: center;
      border: 1.5px dashed #666;
    }

    .avatar {

      width: 103px;
      height: 103px;
    }

    .mid_box {
      flex-direction: row;
    }

    .footer {
      width: 100%;
      margin-top: 80px;
    }
  }

  .box1 {
    font-size: 15px;
    margin-top: 20px;
    word-wrap: break-word;
    white-space: nowrap;
    text-align: center;
  }

  /deep/ .el-dialog__header {
    background: linear-gradient(69deg,
        #cc263f,
        #f42b47 100%,
        #ed162d 0,
        #e60012 0),
      linear-gradient(#e60012, #e60012) !important;
  }

  //项目申报书和项目实施方案
  .options_btn_box {
    margin-right: 70px;
    margin-top: 30px;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .options_btn {
      display: flex;
      align-items: center;
      margin-left: 50px;

      .addN {
        display: inline-block;
        width: 110px;
        text-align: left;
        font-weight: bold;
        font-size: 17px;
      }
    }
  }

  .upload_f_box {

    display: flex;
    align-items: center;

    .options_box {
      width: 200px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
    }
  }

</style>
